/* Free Tarot connects the saved question and cards to a symbolic pattern.
   Optional paid packages add the selected interpretation depth and practical steps. */
(function () {
  'use strict';
  if (!document.querySelector('[data-ft]')) return;

  var PAGE = '/pages/free-tarot-reading';
  var API_BASE = 'https://reading.deckaura.com/api/free-tarot';
  var RAIL_TIERS = ['essential', 'deeper', 'indepth'];
  var ANALYTICS_SCHEMA = 'tarot_funnel_v1';
  var FUNNEL_VERSION = 'free-tarot-pattern-2026-10-22-v10-three-tier';
  var PREVIEW_VERSION = 'ft-preview-v6-pattern';
  var FREE_PATTERN_PROMPT_VERSION = 'ft-pattern-v3';
  var RESULT_MODES = ['success', 'fallback', 'limit', 'validation_error', 'network_error', 'server_error', 'timeout'];
  var DEFAULT_INTENT_ID = 'condition';
  var MIN_QUESTION_LENGTH = 6;
  var QUOTA_KEY = 'deckaura_free_tarot_quota_v1';
  var RESUME_KEY = 'deckaura_free_tarot_resume_v2';
  var HANDOFF_KEY = 'deckaura_reading_handoff';
  var HANDOFF_MAX_AGE = 15 * 60 * 1000;
  var QUOTA_WINDOW_MS = 24 * 60 * 60 * 1000;
  var QA_SESSION_KEY = 'deckaura_free_tarot_qa_v1';
  var I18N = window.DeckauraFreeTarotI18n || null;
  var FT_LOCALE = String(I18N && I18N.locale || document.documentElement.lang || navigator.language || 'en').toLowerCase();
  var FT_LANGUAGE = String(I18N && I18N.language || FT_LOCALE.split('-')[0] || 'en').toLowerCase();
  function msg(key, vars, fallback) {
    return I18N && typeof I18N.text === 'function' ? I18N.text(key, vars, fallback) : String(fallback == null ? key : fallback);
  }
  function readQaToken() {
    var token = '';
    try {
      var hashParams = new URLSearchParams(String(window.location.hash || '').replace(/^#/, ''));
      var supplied = String(hashParams.get('ftqa') || '').trim();
      if (/^v1\.\d{10}\.[a-f0-9]{64}$/.test(supplied)) {
        window.sessionStorage.setItem(QA_SESSION_KEY, supplied);
        token = supplied;
        hashParams.delete('ftqa');
        var cleanHash = hashParams.toString();
        window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search + (cleanHash ? '#' + cleanHash : ''));
      } else token = String(window.sessionStorage.getItem(QA_SESSION_KEY) || '');
    } catch (_) {}
    return /^v1\.\d{10}\.[a-f0-9]{64}$/.test(token) ? token : '';
  }
  var QA_TOKEN = readQaToken();
  function analyticsSuppressed() {
    if (QA_TOKEN) return true;
    try {
      var audit = new URLSearchParams(window.location.search || '');
      return audit.has('funnel_audit') || audit.get('internal') === 'true' || audit.get('traffic_type') === 'internal';
    } catch (_) { return false; }
  }
  function localePayload() {
    var payload = { locale: FT_LOCALE, language: FT_LANGUAGE };
    if (QA_TOKEN) payload.qaToken = QA_TOKEN;
    return payload;
  }
  function cardDisplayName(name) {
    return I18N && typeof I18N.localizeCardName === 'function' ? I18N.localizeCardName(name) : String(name || '');
  }
  function localizedCardMeaning(card, reversed) {
    if (I18N && typeof I18N.localizeCardMeaning === 'function') return I18N.localizeCardMeaning(card, reversed);
    return cardMeaning(card, reversed);
  }
  function sentenceFragment(value) {
    return String(value || '').trim().replace(/[.!?…;:]+$/u, '');
  }
  function openQuestionText(value) {
    var text = String(value || '').replace(/\s+/g, ' ').trim();
    return text.length >= 12 && text.length <= 280 ? text : '';
  }
  /* Non-English answers must not show the English orientation words next to a
     localized card name (seen live: "Siete de Oros reversed"). Mirrors the
     reading server's localizeOrientationWords. */
  var ORIENTATION_WORDS = {
    tr: { reversed: 'ters', upright: 'düz' },
    es: { reversed: 'invertida', upright: 'al derecho' },
    de: { reversed: 'umgekehrt', upright: 'aufrecht' },
    pt: { reversed: 'invertida', upright: 'na posição direita' }
  };
  function localizeOrientationWords(value) {
    var words = ORIENTATION_WORDS[FT_LANGUAGE];
    var text = String(value == null ? '' : value);
    if (!words) return text;
    return text
      .replace(/\(\s*reversed\s*\)/gi, '(' + words.reversed + ')')
      .replace(/\(\s*upright\s*\)/gi, '(' + words.upright + ')')
      .replace(/\breversed\b/gi, '(' + words.reversed + ')')
      .replace(/\bupright\b/gi, '(' + words.upright + ')')
      .replace(/\(\(([^()]+)\)\)/g, '($1)');
  }
  function localizeAnswerText(value, picks) {
    var normalized = canonicalizeAnswerCardNames(value, picks);
    if (!I18N || typeof I18N.replaceCardNames !== 'function') return localizeOrientationWords(normalized);
    return localizeOrientationWords(I18N.replaceCardNames(normalized, (picks || []).map(function (pick) { return pick && pick.card; })));
  }
  function durationLabel(minutes) {
    return msg('durationMinutes', { n: minutes }, minutes + ' min');
  }
  function languageRoute(code) {
    var targetLanguage = String(code || '').toLowerCase();
    try {
      var alternate = document.querySelector('link[rel="alternate"][hreflang="' + targetLanguage + '"]');
      if (alternate && alternate.href) {
        var alternateUrl = new URL(alternate.href, window.location.origin);
        if (alternateUrl.origin === window.location.origin) return alternateUrl.pathname;
      }
    } catch (_) {}
    return {
      en: '/pages/free-tarot-reading',
      tr: '/tr/pages/ucretsiz-tarot-fali',
      es: '/es/pages/tarot-gratis',
      de: '/de/pages/kostenlose-tarotlegung',
      pt: '/pt/pages/leitura-tarot-gratis'
    }[targetLanguage] || '';
  }

  var SPREADS = {
    three: { name: 'Three-Card Clarity', best: 'Best for focused questions and current situations', n: 3, time: 2, pos: ['Situation', 'Hidden influence', 'Possible direction'] },
    decision: { name: 'Decision Crossroads', best: 'Best for choosing between two paths', n: 3, time: 3, pos: ['If you act', 'If you wait', 'What decides it'] },
    love: { name: 'Love Connection', best: 'Best for emotions, communication and relationship dynamics', n: 5, time: 4, pos: ['You', 'Them', 'Between you', 'What is hidden', 'Where it moves'] },
    timing: { name: 'Contact & Timing', best: 'Best for silence, distance and “when” questions', n: 3, time: 3, pos: ['Where it stands', 'What is holding it', 'Pace of movement'] },
    yesno: { name: 'Yes or No', best: 'Best for one direct question', n: 1, time: 1, pos: ['The signal'] },
    celtic: { name: 'Celtic Cross', best: 'Best for major, complex life situations', n: 10, time: 8, pos: ['Situation', 'Challenge', 'Root', 'Recent past', 'Possible outcome', 'Near future', 'Your stance', 'Outside influence', 'Hope or fear', 'Direction'] },
    guide_single: { name: 'Single Card Pull', best: 'Daily guidance, quick answers and meditation focus', n: 1, time: 1, pos: ['The Message'], sourceOnly: true },
    guide_yesno: { name: 'Yes or No', best: 'A direct question that needs a concise signal', n: 1, time: 1, pos: ['The Answer'], sourceOnly: true },
    guide_past_present_future: { name: 'Past, Present, Future', best: 'Understanding timelines and how events connect', n: 3, time: 2, pos: ['Past', 'Present', 'Future'], sourceOnly: true },
    guide_situation_challenge_advice: { name: 'Situation, Challenge, Advice', best: 'Problem-solving and practical guidance', n: 3, time: 2, pos: ['Situation', 'Challenge', 'Advice'], sourceOnly: true },
    guide_mind_body_spirit: { name: 'Mind, Body, Spirit', best: 'A holistic personal check-in', n: 3, time: 2, pos: ['Mind', 'Body', 'Spirit'], sourceOnly: true },
    guide_love: { name: 'Love Spread', best: 'Relationship dynamics, needs and potential', n: 5, time: 4, pos: ['You', 'Them', 'The Connection', 'Challenge', 'Potential'], sourceOnly: true },
    guide_career: { name: 'Career Cross', best: 'Work decisions, obstacles and professional direction', n: 5, time: 4, pos: ['Current Position', 'Obstacle', 'Strength', 'Action', 'Outcome'], sourceOnly: true },
    guide_horseshoe: { name: 'Horseshoe Spread', best: 'A complex situation with visible and hidden influences', n: 7, time: 6, pos: ['Past', 'Present', 'Hidden', 'Obstacle', 'Others', 'Advice', 'Outcome'], sourceOnly: true },
    guide_birthday: { name: 'Birthday Spread', best: 'Reflecting on themes for the year ahead', n: 7, time: 6, pos: ['Year Theme', 'Love', 'Career', 'Health', 'Growth', 'Challenge', 'Gift'], sourceOnly: true },
    guide_new_moon: { name: 'New Moon Spread', best: 'Setting intentions and beginning a new cycle', n: 5, time: 4, pos: ['Seed', 'Soil', 'Water', 'Sun', 'Bloom'], sourceOnly: true },
    guide_celtic_cross: { name: 'Celtic Cross', best: 'A complex question that needs multiple perspectives', n: 10, time: 8, pos: ['Present', 'Challenge', 'Foundation', 'Recent Past', 'Crown', 'Near Future', 'You', 'Environment', 'Hopes and Fears', 'Outcome'], sourceOnly: true },
    guide_full_moon: { name: 'Full Moon Spread', best: 'Revelation, release and integration', n: 6, time: 5, pos: ['Illuminated', 'Harvest', 'Release', 'Gratitude', 'Shadow', 'Integration'], sourceOnly: true }
  };
  var CATS = {
    contact: { label: 'Contact & Reconnection', ph: 'Example: What is preventing communication between us?', spread: 'timing', rec: 1,
      general: 'What should I understand about communication and reconnection right now?',
      examples: ['What is preventing communication between us?', 'What could help this situation move forward?', 'What should I do about the current silence?'],
      why: 'This reads as a communication question.',
      focus: 'Your selected focus keeps this reading on contact, silence and reconnection.',
      names: ['Will They Reach Out?', 'The Contact Decision Reading', 'The Reconnection Path'],
      locked: ['What is actually preventing contact right now', 'What could change the current silence', 'Whether to wait or make the first move'],
      open: 'The cards read this as a pause rather than an ending.' },
    love: { label: 'Love & Relationship', ph: 'Example: What is really happening between us right now?', spread: 'three', rec: 1,
      general: 'What should I understand about this relationship pattern right now?',
      examples: ['What pattern is shaping this relationship?', 'What am I not seeing clearly in this connection?', 'What would be the healthiest next step for me?'],
      why: 'This reads as a relationship question.',
      focus: 'Your selected focus keeps this reading on the relationship dynamic and emotional pattern.',
      names: ['Where This Really Stands', 'The Relationship Decision Reading', 'The Connection Path'],
      locked: ['What is really shaping this connection', 'The condition that could change its direction', 'What to do next without making things worse'],
      open: 'The cards describe a connection that is still forming its shape.' },
    decision: { label: 'A Choice or Two Paths', ph: 'Example: Should I stay in this situation or step away?', spread: 'decision', rec: 2,
      general: 'What should I understand before choosing between these two paths?',
      examples: ['What would help me choose between these paths?', 'What am I overlooking in this decision?', 'Which condition matters most before I decide?'],
      why: 'This reads as a decision between two paths.',
      focus: 'Your selected focus keeps this reading on the choice, its tradeoffs and both paths.',
      names: ['The Strongest Direction', 'The Decision Reading', 'Stay vs Leave Decision Map'],
      locked: ['What is really keeping this decision stuck', 'How each path is likely to unfold', 'What to do first once you choose'],
      open: 'The cards do not show one path as obviously closed.' },
    career: { label: 'Career & Money', ph: 'Example: What should I understand before accepting this opportunity?', spread: 'three', rec: 1,
      general: 'What should I understand about my career and money right now?',
      examples: ['What should I understand about this career decision?', 'What is the real opportunity in front of me?', 'What practical move would strengthen my position?'],
      why: 'This reads as a career and opportunity question.',
      focus: 'Your selected focus keeps this reading on work, money and the opportunity in front of you.',
      names: ['Career Signal', 'The Career Decision Reading', 'Your 30-Day Career Path'],
      locked: ['What this opportunity is actually worth', 'The obstacle and the likely timing', 'The first move to make this week'],
      open: 'The cards weigh this as an opportunity with conditions attached.' },
    next: { label: 'Timing & What’s Next', ph: 'Example: What is coming next for me in the months ahead?', spread: 'three', rec: 1,
      general: 'What should I understand about the direction forming next?',
      examples: ['What is beginning to unfold next?', 'What pace should I expect from this situation?', 'What should I prepare for over the coming weeks?'],
      why: 'This reads as a timing and direction question.',
      focus: 'Your selected focus keeps this reading on timing, direction and what is beginning to unfold.',
      names: ['Your Core Message', 'The Timing Decision Reading', 'Your Month-Ahead Map'],
      locked: ['What is really shaping this outcome', 'The condition that could change the path', 'What to do next without making things worse'],
      open: 'The cards point to a theme already forming rather than a sudden turn.' },
    other: { label: 'Another Situation', ph: 'What would you like clarity on?', spread: 'three', rec: 1,
      general: 'What should I understand about my current situation right now?',
      examples: ['What is the central pattern in this situation?', 'What am I not seeing clearly right now?', 'What would be the most grounded next step?'],
      why: 'A three-card reading fits this question.',
      focus: 'Your selected focus keeps this as an open three-card reading around one clear situation.',
      names: ['Your Core Message', 'The Decision Reading', 'Your Month-Ahead Map'],
      locked: ['What is really shaping this outcome', 'The condition that could change the path', 'What to do next without making things worse'],
      open: 'The cards give a clear enough direction to work with.' }
  };

  function normalizeGuideHandoff(packet) {
    if (!packet || packet.type !== 'Tarot' || !packet.data || packet.source !== 'tarot-spreads') return null;
    var createdAt = Number(packet.createdAt) || 0;
    var expiresAt = Number(packet.expiresAt) || (createdAt + HANDOFF_MAX_AGE);
    if (!createdAt || Date.now() - createdAt > HANDOFF_MAX_AGE || Date.now() > expiresAt) return null;
    var key = String(packet.data.spreadKey || '');
    var spread = SPREADS[key];
    if (!spread || !spread.sourceOnly) return null;
    var suppliedPositions = Array.isArray(packet.data.positions) ? packet.data.positions : [];
    if (suppliedPositions.length !== spread.n) return null;
    var normalizedPositions = suppliedPositions.map(function (position) {
      return String(position && position.name || '').trim().slice(0, 80);
    });
    var positionsMatch = spread.pos.every(function (name, index) {
      return name.toLowerCase() === normalizedPositions[index].toLowerCase();
    });
    if (!positionsMatch) return null;
    var category = String(packet.data.category || 'other');
    if (!CATS[category]) category = 'other';
    var suppliedQuestion = String(packet.question || '').trim().slice(0, 240);
    return {
      key: key,
      name: spread.name,
      category: category,
      question: suppliedQuestion || ('What should I understand through this ' + spread.name + ' reading right now?'),
      positions: spread.pos.slice(),
      source: 'tarot-spreads'
    };
  }

  function consumeGuideHandoff() {
    var packet = null;
    try { packet = JSON.parse(sessionStorage.getItem(HANDOFF_KEY) || 'null'); } catch (_) {}
    var handoff = normalizeGuideHandoff(packet);
    if (!handoff) {
      if (packet && packet.source === 'tarot-spreads') {
        try { sessionStorage.removeItem(HANDOFF_KEY); } catch (_) {}
      }
      return null;
    }
    try {
      sessionStorage.removeItem(HANDOFF_KEY);
      sessionStorage.removeItem(SESSION_KEY);
    } catch (_) {}
    s.phase = 'ask';
    s.q = handoff.question;
    s.cat = handoff.category;
    s.spread = handoff.key;
    s.handoff = handoff;
    s.deck = [];
    s.picked = [];
    s.qErr = false;
    s.tier = null;
    s.intent = '';
    s.server = null;
    s.readingId = '';
    s.attemptId = '';
    s.sentEvents = {};
    s.questionStarted = false;
    s.resultIndex = 0;
    return handoff;
  }

  var TIERS = [
    { base: 'The Answer', tag: 'Essential', words: '450–600 words · delivered by email',
      promise: 'One clear answer and one grounded next step.',
      bullets: ['Direct answer to your exact question', 'The strongest signal in your cards', 'One condition to pay attention to', 'One practical next move'],
      cta: 'Get My Answer' },
    { base: 'The Decision Reading', tag: 'Focused', words: '750–950 words · delivered by email',
      promise: 'Turn the recognized pattern into a decision you can act on.',
      bullets: ['Every card connected to your exact question', 'The condition to verify before deciding', 'Evidence and timing signals to watch', 'What strengthens or weakens each direction', 'Three concrete next actions'],
      cta: 'Get My Decision Reading' },
    { base: 'The Path Ahead', tag: 'In-Depth', words: '1,250–1,500 words · delivered by email',
      promise: 'Compare the paths before you make your move.',
      bullets: ['Everything in Focused Reading', 'The path if you act versus if you wait', 'Alternative outcomes and hidden risks', 'Red flags and safeguards', 'Your practical 30-day guidance map'],
      cta: 'Map My Path' }
  ];
  var INTENTS = [
    { id: 'condition', title: 'Resolve this decision', tier: 1, number: '01',
      detail: 'Verify the deciding evidence, understand what changes the outcome and leave with three next actions.' },
    { id: 'paths', title: 'Compare how this unfolds', tier: 2, number: '02',
      detail: 'Understand the difference between the paths before you commit to one.' },
    { id: 'next', title: 'Find my clearest next step', tier: 1, number: '03',
      detail: 'Turn the shared pattern into one grounded, practical move.' }
  ];
  if (I18N && typeof I18N.localizeConfig === 'function') I18N.localizeConfig({ spreads: SPREADS, categories: CATS, intents: INTENTS });

  /* ------------ state ------------ */
  var s = {
    phase: 'ask', q: '', followup: '', cat: null, spread: null, positions: null, sheet: false, deck: [], picked: [],
    qErr: false, faq: -1, live: '', drawBusy: false, drawError: '', w: window.innerWidth,
    tier: null, intent: '', server: null, readingId: '', busy: false,
    railReadingId: '', checkoutQueued: false, checkoutVia: '', checkoutBusy: false,
    sessionId: '', attemptId: '', sentEvents: {}, questionStarted: false, handoff: null,
    resultIndex: 0, draft: '', entitlementStatus: 'checking', resumeToken: '', resumeAvailable: false,
    resumeOtherLanguage: '', resumeOtherLanguageAvailable: false,
    pricing: { status: 'idle', source: 'live', checkout_allowed: false, retryable: false, currency: '', latency_ms: 0, error_code: '', tiers: [] }
  };
  var SESSION_KEY = 'deckaura_tarot_funnel_v1_state_' + FT_LANGUAGE;
  var SESSION_ID_KEY = 'deckaura_tarot_funnel_v1_session_id';
  function pricingCheckoutReady() {
    return (s.pricing.status === 'ready' || s.pricing.status === 'fallback_ready') && s.pricing.checkout_allowed === true;
  }
  var SESSION_MAX_AGE = 2 * 60 * 60 * 1000;
  var sheetScrollY = 0;
  var sheetTrigger = null;
  var sheetBodyOverflow = '';
  var sheetBodyPaddingRight = '';
  var milestoneObserver = null;
  var seenMilestones = {};
  var visibilityTimers = {};
  var primaryCtaView = null;
  var primaryCtaViewTimer = 0;
  var primaryCtaMutationObserver = null;
  var primaryCtaObserved = null;
  var engagedVisible = false;
  var engagedLastTick = 0;
  var engagedMs = 0;
  var engagedTimer = 0;
  var quotaExpiresAt = 0;
  var pricingAutoRetryCount = 0;
  var pricingAutoRetryTimer = 0;
  var pricingNoticeShown = false;
  var deckReadyTimer = 0;
  var checkoutRailPromise = null;
  var checkoutRailRuntimePending = 0;
  var checkoutRailAuxiliaryScripts = Object.create(null);
  var activeAnswerRequest = null;
  var answerNavigationSuspended = false;
  var storageWriteId = 0;
  var pendingStorageWrite = null;
  var storageCheckWorker = null;
  var storageWorkerUnavailable = false;
  var storageWorkerTimer = 0;
  var storageScreenCache = [];

  function safeId(value) { return /^[a-zA-Z0-9_-]{12,96}$/.test(String(value || '')); }
  function uuid(prefix) {
    try {
      if (crypto && typeof crypto.randomUUID === 'function') return (prefix || '') + crypto.randomUUID();
      var bytes = new Uint8Array(16); crypto.getRandomValues(bytes);
      return (prefix || '') + Array.prototype.map.call(bytes, function (x) { return x.toString(16).padStart(2, '0'); }).join('');
    } catch (_) { return (prefix || '') + Date.now().toString(36) + Math.random().toString(36).slice(2, 14); }
  }
  function sessionId() {
    try {
      var existing = sessionStorage.getItem(SESSION_ID_KEY);
      if (safeId(existing)) return existing;
      var next = uuid('s_');
      sessionStorage.setItem(SESSION_ID_KEY, next);
      return next;
    } catch (_) { return uuid('s_'); }
  }
  function cleanToken(value, max) {
    return String(value == null ? '' : value).toLowerCase().replace(/[^a-z0-9_:-]/g, '_').slice(0, max || 80);
  }
  function safeEventData(data) {
    var allowed = {
      category: 1, spread: 1, card_count: 1, selected_count: 1, result_mode: 1,
      source: 1, intent: 1, tier: 1, via: 1, status: 1, currency: 1,
      latency_ms: 1, error_code: 1, variant_id: 1, price_minor: 1, available: 1,
      reason: 1, destination: 1, result_index: 1, result_total: 1, item_count: 1,
      preview_version: 1, prompt_version: 1, payment_method: 1
    };
    var out = {};
    Object.keys(data || {}).forEach(function (key) {
      if (!allowed[key]) return;
      var value = data[key];
      if (typeof value === 'number' && Number.isFinite(value)) out[key] = value;
      else if (typeof value === 'boolean') out[key] = value;
      else if (value != null) out[key] = key === 'currency'
        ? String(value).toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3)
        : cleanToken(value, key === 'variant_id' ? 24 : 80);
    });
    return out;
  }
  function legacyFunnelAliases(name, data) {
    var direct = {
      tarot_funnel_viewed: 'ft_v2_page_ready',
      category_selected: 'ft_v2_category',
      spread_selected: 'ft_v2_spread',
      draw_succeeded: 'ft_v2_draw',
      free_result_requested: 'ft_v2_result',
      continuation_selected: 'ft_v2_intent_selected',
      package_selected: 'ft_v2_tier_selected',
      checkout_price_waiting: 'ft_v2_checkout_queued',
      checkout_cart_verified: 'ft_v2_cart_verified',
      checkout_started: 'ft_v2_checkout_started',
      checkout_failed: 'ft_v2_checkout_failed',
      free_result_navigation: 'ft_v2_result_advance',
      offer_viewed: 'ft_v2_locked_preview_viewed',
      offer_opened: 'ft_v2_locked_preview_clicked'
    };
    if (direct[name]) return [direct[name]];
    if (name === 'free_result_resolved') {
      var mode = String(data && data.result_mode || 'server_error');
      if (mode === 'success' || mode === 'fallback') return ['ft_v2_answer_ready'];
      if (mode === 'limit') return ['ft_v2_free_limit_reached'];
      return ['ft_v2_answer_failed'];
    }
    if (name === 'draw_blocked' && data && data.reason === 'cards_incomplete') return ['ft_v2_reveal_prerequisite'];
    if (name === 'checkout_blocked' && data && data.reason === 'reading_incomplete') return ['ft_v2_checkout_prerequisite'];
    if (name === 'checkout_blocked' && data && data.reason === 'continuation_required') return ['ft_v2_intent_required'];
    return [];
  }
  function emitAnalyticsEvent(name, payload, dispatchInternal) {
    if (analyticsSuppressed()) return;
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (_) {}
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (_) {}
    try {
      if (Array.isArray(window.dataLayer)) window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (_) {}
    if (dispatchInternal) {
      try { document.dispatchEvent(new CustomEvent('deckaura:tarot-funnel-event', { detail: { name: name, payload: payload } })); } catch (_) {}
    }
  }
  function durableFreeValueStatus(data) {
    var mode = String(data && data.result_mode || '');
    if (!mode) {
      var status = s.server && s.server.status;
      if (status === 'ready') return 'delivered';
      if (status === 'limited') return 'visitor_limit';
      return status === 'error' ? 'error' : '';
    }
    if (mode === 'success' || mode === 'fallback') return 'delivered';
    if (mode === 'limit') return 'visitor_limit';
    return 'error';
  }
  function queueDurableFunnelEvent(name, data) {
    if (analyticsSuppressed()) return;
    var map = {
      question_validated: [{ name: 'question_accepted', status: 'accepted' }],
      draw_submitted: [{ name: 'picker_view', status: 'viewed' }],
      cards_completed: [{ name: 'cards_complete', status: 'completed' }],
      free_result_resolved: [
        { name: 'result_view', status: 'viewed', freeValue: true },
        { name: 'free_answer_view', status: 'viewed', freeValue: true }
      ],
      paid_primary_cta_viewed: [{ name: 'primary_cta_view', status: 'viewed', freeValue: true }],
      paid_primary_cta_clicked: [{ name: 'cta_click', status: 'clicked', freeValue: true }],
      checkout_started: [{ name: 'checkout_handoff', status: 'handoff', freeValue: true }]
    };
    var stages = map[name];
    if (!stages) return;
    var freeValueStatus = durableFreeValueStatus(data);
    var flowId = safeId(s.attemptId) ? s.attemptId : s.sessionId;
    var locale = String(document.documentElement.lang || navigator.language || 'en').toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 24) || 'en';
    var device = window.innerWidth <= 720 ? 'mobile' : (window.innerWidth <= 1024 ? 'tablet' : 'desktop');
    stages.forEach(function (stage) {
      var requiresFreeValue = stage.freeValue === true;
      if (requiresFreeValue && (!freeValueStatus || (stage.name === 'free_answer_view' && freeValueStatus !== 'delivered'))) return;
      var metadata = {
        flow_id: flowId,
        experience_version: 'free-tarot-enterprise-2026-08-v45',
        status: stage.status,
        source: 'free_tarot',
        device: device,
        locale: locale,
        funnel_step: stage.name
      };
      if (requiresFreeValue) metadata.free_value_status = freeValueStatus;
      if (stage.name === 'cards_complete') metadata.selected_count = Math.max(0, Math.min(78, Number(data && data.selected_count) || drawn().length));
      if (['primary_cta_view', 'cta_click', 'checkout_handoff'].indexOf(stage.name) >= 0) {
        metadata.offer_variant = 'decision_reading_primary';
        metadata.package_tier = 'medium';
      }
      var event = {
        eventId: uuid(),
        eventName: stage.name,
        readingId: s.readingId || flowId,
        page: PAGE,
        readingMode: 'free_tarot',
        funnelVersion: FUNNEL_VERSION,
        recommendedTier: 'medium',
        selectedTier: s.tier === null ? '' : ['standard', 'medium', 'premium'][s.tier],
        metadata: metadata,
        occurredAt: new Date().toISOString()
      };
      var input = { visitorId: visitorId(), event: event };
      if (window.DeckauraFunnelDelivery && typeof window.DeckauraFunnelDelivery.enqueue === 'function') window.DeckauraFunnelDelivery.enqueue(input);
      else {
        window.DeckauraFunnelDeliveryQueue = window.DeckauraFunnelDeliveryQueue || [];
        window.DeckauraFunnelDeliveryQueue.push(input);
      }
    });
  }
  function publishFunnelEvent(name, data, options) {
    if (analyticsSuppressed()) return false;
    if (!/^[a-z][a-z0-9_]{2,64}$/.test(String(name || ''))) return false;
    if (name === 'free_result_resolved' && RESULT_MODES.indexOf(String(data && data.result_mode || '')) < 0) {
      data = Object.assign({}, data || {}, { result_mode: 'server_error' });
    }
    var once = options && options.once === true;
    var scope = s.attemptId || s.sessionId || 'page';
    var dedupeKey = scope + ':' + name;
    if (name === 'free_result_resolved') dedupeKey += ':' + durableFreeValueStatus(data);
    if (once && s.sentEvents[dedupeKey]) return false;
    var payload = Object.assign({
      analytics_schema: ANALYTICS_SCHEMA,
      funnel_version: FUNNEL_VERSION,
      session_id: s.sessionId,
      attempt_id: s.attemptId || '',
      reading_id: s.readingId || '',
      event_uuid: uuid('e_'),
      occurred_at: new Date().toISOString()
    }, safeEventData(data));
    if (once) {
      s.sentEvents[dedupeKey] = payload.event_uuid;
      persistState();
    }
    emitAnalyticsEvent(name, payload, true);
    queueDurableFunnelEvent(name, data || {});
    legacyFunnelAliases(name, data).forEach(function (alias) {
      emitAnalyticsEvent(alias, Object.assign({}, payload, { canonical_event: name, analytics_schema: 'free_tarot_v2_compat' }), false);
    });
    return true;
  }
  function ensureAttempt(source) {
    if (s.attemptId) return s.attemptId;
    s.attemptId = uuid('a_');
    s.sentEvents = {};
    publishFunnelEvent('first_interaction', { source: source || 'unknown' }, { once: true });
    persistState();
    return s.attemptId;
  }

  function commitStorageWrite(packet, urgent) {
    if (!packet || packet.id !== storageWriteId) return;
    if (storageWorkerTimer) clearTimeout(storageWorkerTimer);
    storageWorkerTimer = 0;
    pendingStorageWrite = null;
    try {
      var serialized = packet.serialized;
      if (urgent || packet.safetyHeld) {
        var safe = JSON.parse(serialized);
        safe.state.phase = 'ask'; safe.state.q = ''; safe.state.followup = '';
        serialized = JSON.stringify(safe);
      }
      sessionStorage.setItem(SESSION_KEY, serialized);
    } catch (_) {}
  }
  function flushStorageWrite() {
    var packet = pendingStorageWrite;
    if (!packet) return;
    commitStorageWrite(packet, crisisUrgent(packet.question) || crisisUrgent(packet.followup));
  }
  function storageWorkerFailed() {
    storageWorkerUnavailable = true;
    if (storageCheckWorker) { storageCheckWorker.terminate(); storageCheckWorker = null; }
    flushStorageWrite();
  }
  function screenStorageWrite(packet) {
    if (storageWorkerUnavailable || typeof window.Worker !== 'function') { flushStorageWrite(); return; }
    try {
      if (!storageCheckWorker) {
        var host = document.querySelector('[data-ft-storage-worker-url]');
        var source = document.querySelector('script[src*="/assets/deckaura-crisis-guard.js"]');
        if (!host || !host.getAttribute('data-ft-storage-worker-url') || !source) { storageWorkerFailed(); return; }
        storageCheckWorker = new Worker(host.getAttribute('data-ft-storage-worker-url'));
        storageCheckWorker.onmessage = function (event) {
          var response = event.data || {};
          if (!pendingStorageWrite || response.id !== pendingStorageWrite.id) return;
          if (typeof response.questionUrgent !== 'boolean' || typeof response.followupUrgent !== 'boolean') { storageWorkerFailed(); return; }
          storageScreenCache = [
            { text: pendingStorageWrite.question, urgent: response.questionUrgent },
            { text: pendingStorageWrite.followup, urgent: response.followupUrgent }
          ];
          commitStorageWrite(pendingStorageWrite, response.questionUrgent || response.followupUrgent);
        };
        storageCheckWorker.onerror = storageWorkerFailed;
      }
      if (!storageWorkerTimer) storageWorkerTimer = window.setTimeout(storageWorkerFailed, 4000);
      storageCheckWorker.postMessage({ id: packet.id, question: packet.question, followup: packet.followup, guardUrl: document.querySelector('script[src*="/assets/deckaura-crisis-guard.js"]').src });
    } catch (_) { storageWorkerFailed(); }
  }
  function persistState(forceSync) {
    try {
      /* The exact snapshot is screened before storage. Stale worker replies cannot restore an older question. */
      var packet = {
        id: ++storageWriteId, question: s.q, followup: s.followup,
        safetyHeld: Boolean(s.safetyHeldQ && s.safetyHeldQ === s.q),
        serialized: JSON.stringify({
        v: 1,
        at: Date.now(),
        state: {
          phase: s.phase, q: s.q, followup: s.followup, cat: s.cat, spread: s.spread, positions: s.positions,
          deck: s.deck, picked: s.picked, tier: s.tier, intent: s.intent,
          server: s.server, readingId: s.readingId,
          sessionId: s.sessionId, attemptId: s.attemptId, sentEvents: s.sentEvents,
          questionStarted: s.questionStarted, resultIndex: s.resultIndex,
          handoff: s.handoff && s.handoff.source === 'tarot-spreads' ? s.handoff : null
        }
        })
      };
      pendingStorageWrite = packet;
      if (forceSync === true || (!String(s.q || '').trim() && !String(s.followup || '').trim())) flushStorageWrite();
      else screenStorageWrite(packet);
    } catch (_) {}
  }
  function restoreState() {
    try {
      var saved = JSON.parse(sessionStorage.getItem(SESSION_KEY) || 'null');
      if (!saved || saved.v !== 1 || !saved.at || Date.now() - saved.at > SESSION_MAX_AGE || !saved.state) {
        sessionStorage.removeItem(SESSION_KEY);
        return false;
      }
      var next = saved.state;
      if (['ask', 'chamber', 'result'].indexOf(next.phase) < 0) return false;
      if (next.phase !== 'ask' && (!Array.isArray(next.deck) || !next.deck.length)) return false;
      if (next.phase === 'result' && (!Array.isArray(next.picked) || !next.picked.length)) return false;
      s.phase = next.phase;
      var savedQuestion = String(next.q || '').slice(0, 240);
      s.q = next.phase === 'ask' ? '' : savedQuestion;
      s.draft = next.phase === 'ask' ? savedQuestion : '';
      s.followup = String(next.followup || '').slice(0, 240);
      s.cat = next.cat && CATS[next.cat] ? next.cat : null;
      s.spread = next.spread && SPREADS[next.spread] ? next.spread : null;
      s.positions = savedPositions(next.positions, next.phase !== 'ask');
      s.deck = Array.isArray(next.deck) ? next.deck : [];
      s.picked = Array.isArray(next.picked) ? next.picked.filter(function (n) { return Number.isInteger(n) && n >= 0 && n < s.deck.length; }) : [];
      s.tier = Number.isInteger(next.tier) && next.tier >= 0 && next.tier < RAIL_TIERS.length ? next.tier : null;
      s.intent = INTENTS.some(function (item) { return item.id === next.intent; }) ? next.intent : '';
      s.server = next.server && typeof next.server === 'object' ? next.server : null;
      s.readingId = String(next.readingId || '');
      s.sessionId = safeId(next.sessionId) ? String(next.sessionId) : s.sessionId;
      s.attemptId = safeId(next.attemptId) ? String(next.attemptId) : '';
      s.sentEvents = next.sentEvents && typeof next.sentEvents === 'object' ? next.sentEvents : {};
      s.questionStarted = next.questionStarted === true;
      s.handoff = next.handoff && next.handoff.source === 'tarot-spreads' && next.spread && SPREADS[next.spread] && SPREADS[next.spread].sourceOnly
        ? { key: String(next.spread), name: SPREADS[next.spread].name, category: s.cat || 'other', positions: SPREADS[next.spread].pos.slice(), source: 'tarot-spreads' }
        : null;
      if (s.phase === 'ask' && !s.handoff) { s.cat = null; s.spread = null; }
      s.resultIndex = Number.isInteger(next.resultIndex) && next.resultIndex >= 0 ? next.resultIndex : 0;
      // Older sessions accepted four- or five-character questions. Reopen that
      // exact text in the existing editor before resuming an incompatible result.
      if (s.phase !== 'ask' && s.q.trim().length < MIN_QUESTION_LENGTH) {
        s.phase = 'ask'; s.qErr = true;
        s.deck = []; s.picked = []; s.server = null; s.readingId = '';
        s.intent = ''; s.tier = null; s.attemptId = ''; s.sentEvents = {}; s.questionStarted = false;
        var completionMessage = 'Write a question with at least 6 characters, or choose the general three-card reading below.';
        s.live = I18N && typeof I18N.staticText === 'function' ? I18N.staticText(completionMessage) : completionMessage;
        window.setTimeout(focusComposer, 40);
      }
      // A refresh interrupts the browser request, not the reading. Boot resumes
      // pending work using this exact reading ID and selected cast.
      setComposerValue(s.q);
      s.w = window.innerWidth;
      return true;
    } catch (_) {
      try { sessionStorage.removeItem(SESSION_KEY); } catch (_) {}
      return false;
    }
  }

  function deckData() {
    var d = window.DeckauraTarotCards;
    return Array.isArray(d) && d.length === 78 ? d : null;
  }
  var ROMAN = ['0', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'XIII', 'XIV', 'XV', 'XVI', 'XVII', 'XVIII', 'XIX', 'XX', 'XXI'];
  function cardSig(card) {
    var cardName = String(card.name || '');
    if (card.arcana === 'Major' || card.suit === 'Major' || cardName.indexOf(' of ') < 0) return ROMAN[card.number] || String(card.number);
    var m = String(card.name || '').match(/^(Ace|Two|Three|Four|Five|Six|Seven|Eight|Nine|Ten|Page|Knight|Queen|King) of (\w+)/);
    if (!m) return card.suit || '';
    var rankMap = { Ace: 'Ace', Two: 'II', Three: 'III', Four: 'IV', Five: 'V', Six: 'VI', Seven: 'VII', Eight: 'VIII', Nine: 'IX', Ten: 'X', Page: 'Page', Knight: 'Knight', Queen: 'Queen', King: 'King' };
    var localizedRanks = {
      tr: { Ace: 'As', Page: 'Uşak', Knight: 'Şövalye', Queen: 'Kraliçe', King: 'Kral' },
      es: { Ace: 'As', Page: 'Sota', Knight: 'Caballero', Queen: 'Reina', King: 'Rey' },
      de: { Ace: 'Ass', Page: 'Bube', Knight: 'Ritter', Queen: 'Königin', King: 'König' },
      pt: { Ace: 'Ás', Page: 'Pajem', Knight: 'Cavaleiro', Queen: 'Rainha', King: 'Rei' }
    };
    var localizedSuits = {
      tr: { Cups: 'Kupa', Pentacles: 'Tılsım', Swords: 'Kılıç', Wands: 'Değnek' },
      es: { Cups: 'Copas', Pentacles: 'Oros', Swords: 'Espadas', Wands: 'Bastos' },
      de: { Cups: 'Kelche', Pentacles: 'Münzen', Swords: 'Schwerter', Wands: 'Stäbe' },
      pt: { Cups: 'Copas', Pentacles: 'Ouros', Swords: 'Espadas', Wands: 'Paus' }
    };
    var suitShort = localizedSuits[FT_LANGUAGE] && localizedSuits[FT_LANGUAGE][m[2]] || (m[2] === 'Pentacles' ? 'Pent' : m[2]);
    var rankShort = localizedRanks[FT_LANGUAGE] && localizedRanks[FT_LANGUAGE][m[1]] || rankMap[m[1]];
    return suitShort + ' · ' + rankShort;
  }
  function cardMeaning(card, reversed) {
    var t = String(reversed ? (card.reversed || card.upright) : card.upright || '').trim();
    if (t && !/[.!?]$/.test(t)) t += '.';
    return t.charAt(0).toUpperCase() + t.slice(1);
  }

  function cardImg(name) {
    return window.DeckauraTarotArt ? window.DeckauraTarotArt.url(name, 420) : '';
  }
  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i += 1) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function rand(seed) {
    var a = seed >>> 0;
    return function () {
      a = (a + 0x6D2B79F5) >>> 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function detect(q) {
    var t = String(q || '').toLocaleLowerCase(FT_LANGUAGE === 'tr' ? 'tr-TR' : undefined).trim();
    var folded = ' ' + t.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9çğıöşüß]+/gi, ' ').replace(/\s+/g, ' ').trim() + ' ';
    function has(arr) { return arr.some(function (phrase) { return t.indexOf(phrase) >= 0; }); }
    function hasWord(arr) {
      return arr.some(function (word) {
        var safe = String(word).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase(FT_LANGUAGE === 'tr' ? 'tr-TR' : undefined);
        return folded.indexOf(' ' + safe + ' ') >= 0;
      });
    }
    if (!t.trim()) return 'other';
    var explicitPair = has([
      'stay or leave', 'leave or stay', 'accept or reject', 'choose between', 'between two', 'two paths', 'which path', 'option a', 'option b',
      'kalmak mı', 'gitmek mi', 'mi yoksa', 'mı yoksa', 'mu yoksa', 'mü yoksa', 'iki yol', 'arasında seçim',
      'quedarme o irme', 'aceptar o rechazar', 'entre dos', 'dos caminos',
      'bleiben oder gehen', 'annehmen oder ablehnen', 'zwischen zwei', 'zwei wege',
      'ficar ou ir', 'aceitar ou rejeitar', 'entre dois', 'dois caminhos'
    ]) || /\s(?:vs\.?|versus)\s/i.test(' ' + t + ' ')
      || (/\s(?:or|oder|ou|yoksa)\s/i.test(' ' + t + ' ') && has(['should i', 'do i ', 'is it better', 'would it be better', 'soll ich', 'devo ', 'debería', 'deberia']))
      || /\b(?:mi|mı|mu|mü)\b.+\b(?:mi|mı|mu|mü)\b/i.test(t);
    if (explicitPair) return 'decision';
    if (hasWord(['job', 'work', 'career', 'money', 'business', 'offer', 'opportunity', 'promotion', 'salary', 'interview', 'iş', 'kariyer', 'para', 'teklif', 'fırsat', 'trabajo', 'carrera', 'dinero', 'oferta', 'oportunidad', 'empleo', 'beruf', 'karriere', 'geld', 'angebot', 'arbeit', 'trabalho', 'carreira', 'dinheiro', 'oportunidade', 'emprego', 'salário']) || has(['new role'])) return 'career';
    if (hasWord(['contact', 'text', 'message', 'respond', 'reply', 'ghost', 'silence', 'block', 'mesaj', 'arayacak', 'ulaş', 'contacto', 'mensaje', 'responder', 'silencio', 'bloque', 'kontakt', 'nachricht', 'antwort', 'schweigen', 'blockiert', 'contato', 'mensagem', 'silêncio', 'bloqueado']) || has(['call me', 'reach out', 'hear from', 'döner mi'])) return 'contact';
    if (hasWord(['love', 'feelings', 'relationship', 'marriage', 'partner', 'aşk', 'sevgi', 'ilişki', 'hissed', 'amor', 'sentimientos', 'relación', 'pareja', 'matrimonio', 'liebe', 'gefühle', 'beziehung', 'vermisst', 'sentimentos', 'relação', 'relacao', 'relacionamento', 'parceiro', 'casamento']) || has(['feel about', 'miss me'])) return 'love';
    if (hasWord(['when', 'next', 'future', 'coming', 'month', 'gelecek', 'cuándo', 'futuro', 'próximo', 'wann', 'zukunft', 'kommenden', 'quando', 'proximo', 'mês', 'mes']) || has(['how long', 'ne zaman', 'ne olacak', 'cuanto tiempo', 'qué viene', 'wie lange', 'als nächstes', 'quanto tempo', 'vem a seguir'])) return 'next';
    return 'other';
  }
  function cat() { return s.cat || detect(s.q); }
  function spreadKey() { return s.spread || CATS[cat()].spread; }
  function need() { return SPREADS[spreadKey()].n; }
  function savedPositions(positions, legacy) {
    var spread = SPREADS[spreadKey()];
    if (Array.isArray(positions) && positions.length === spread.n && positions.every(function (value) { return typeof value === 'string' && value.trim() && value.length <= 120; })) return positions.slice();
    // Sessions from before this release did not save position labels. Preserve
    // their original third position rather than reassigning already drawn cards.
    var oldThree = { en: ['Situation', 'Hidden influence', 'Best next step'], tr: ['Durum', 'Gizli etki', 'En sağlam sonraki adım'], es: ['Situación', 'Influencia oculta', 'Siguiente paso más sólido'], de: ['Situation', 'Verborgener Einfluss', 'Stärkster nächster Schritt'], pt: ['Situação', 'Influência oculta', 'Próximo passo mais sólido'] };
    return legacy && spreadKey() === 'three' ? (oldThree[FT_LANGUAGE] || oldThree.en).slice() : spread.pos.slice();
  }
  function currentSpread() {
    var spread = SPREADS[spreadKey()];
    return Object.assign({}, spread, { pos: Array.isArray(s.positions) && s.positions.length === spread.n ? s.positions.slice() : spread.pos.slice() });
  }
  function isServiceCapacityLimit(response) {
    return !!(response && response.status === 429 && response.data && response.data.limitScope === 'service_capacity');
  }
  function freePatternPreview(server) {
    // Old saved replies can contain complete advice. Only the bounded pattern
    // contract may contribute server prose; raw answer text is never rendered.
    if (!server || server.previewVersion !== PREVIEW_VERSION || server.promptVersion !== FREE_PATTERN_PROMPT_VERSION || !server.preview || typeof server.preview !== 'object') return null;
    var recognition = String(server.preview.recognition || '').trim();
    if (!recognition || recognition.length > 420) return null;
    return { recognition: recognition, unresolvedQuestion: String(server.preview.unresolvedQuestion || '').trim().slice(0, 220) };
  }
  function tierIndex() { return Number.isInteger(s.tier) && s.tier >= 0 && s.tier < RAIL_TIERS.length ? s.tier : CATS[cat()].rec; }
  function intentConfig() { return INTENTS.find(function (item) { return item.id === s.intent; }) || null; }
  function categoryDisplay(key) {
    return CATS[key] && CATS[key].label || CATS.other.label;
  }
  function drawn() {
    return s.picked.map(function (n) { return s.deck[n]; }).filter(Boolean);
  }

  /* ------------ compute (design renderVals portu) ------------ */
  function computeVals() {
    var catKey = cat(), C = CATS[catKey];
    var sk = spreadKey(), SP = currentSpread();
    var needN = SP.n;
    var wide = s.w >= 900, mob = s.w < 640;

    var cats = Object.keys(CATS).map(function (k) {
      var on = s.cat === k;
      return { label: CATS[k].label, on: on,
        bg: on ? '#D9BC7E' : 'transparent',
        border: on ? '#D9BC7E' : 'rgba(243,239,230,0.2)',
        color: on ? '#1A1408' : '#E6E1EC',
        weight: on ? '700' : '500', check: on ? '✓' : '' };
    });
    var examples = C.examples.map(function (label) { return { label: label }; });
    var spreads = Object.keys(SPREADS).filter(function (k) { return !SPREADS[k].sourceOnly; }).map(function (k) {
      var sp = SPREADS[k], on = sk === k;
      return { name: sp.name, best: sp.best, meta: sp.n + ' ' + msg(sp.n === 1 ? 'card' : 'cards', null, sp.n === 1 ? 'card' : 'cards') + ' · ' + durationLabel(sp.time),
        on: on, tick: on ? '✓' : '',
        bg: on ? '#262235' : '#1D1A28',
        border: on ? 'rgba(217,188,126,0.6)' : 'rgba(243,239,230,0.14)',
        dot: on ? '#D9BC7E' : 'rgba(243,239,230,0.28)' };
    });

    var shown = mob ? s.deck.slice(0, 11) : s.deck;
    var mid = (shown.length - 1) / 2;
    var deckCards = shown.map(function (d, i) {
      var on = s.picked.indexOf(i) >= 0;
      var rot = (i - mid) * 3.1;
      var lift = Math.abs(i - mid) * Math.abs(i - mid) * 0.42;
      return { on: on,
        tf: 'rotate(' + rot.toFixed(2) + 'deg) translateY(' + (lift + (on ? -30 : 0)).toFixed(1) + 'px)',
        tfHover: 'rotate(' + rot.toFixed(2) + 'deg) translateY(' + (lift + (on ? -30 : -10)).toFixed(1) + 'px)',
        gap: i === 0 ? '0px' : 'calc(clamp(74px,7.6vw,104px) * -0.37)',
        aria: msg('cardNumber', { n: i + 1 }, 'Card ' + (i + 1)) + ', ' + (on ? msg('selected', null, 'selected') : msg('notSelected', null, 'not selected')),
        removeAria: msg('removeCard', { n: i + 1 }, 'Remove selected card ' + (i + 1)),
        border: on ? 'rgba(201,169,106,0.85)' : 'rgba(201,169,106,0.22)',
        mark: on ? 'rgba(201,169,106,0.85)' : 'rgba(201,169,106,0.4)',
        shadow: on ? '0 24px 48px rgba(77,52,31,0.24), 0 0 0 1px rgba(185,133,52,0.38)' : '0 14px 30px rgba(77,52,31,0.18)' };
    });

    var picks = drawn();
    var preview = freePatternPreview(s.server);
    var contextualInsights = [];
    var resultCards = picks.map(function (d, i) {
      var contextual = FT_LANGUAGE === 'en' && contextualInsights[i] && String(contextualInsights[i].insight || '').trim();
      var traditional = localizedCardMeaning(d.card, d.rev);
      var displayName = cardDisplayName(d.card.name);
      var position = SP.pos[i] || msg('cardNumber', { n: i + 1 }, 'Card ' + (i + 1));
      return {
        pos: position,
        name: displayName, sig: cardSig(d.card),
        img: cardImg(d.card.name),
        meaning: localizeAnswerText(contextual || traditional, picks),
        traditionalMeaning: traditional,
        orient: d.rev ? msg('reversed', null, 'Reversed') : msg('upright', null, 'Upright'),
        markTf: d.rev ? 'rotate(180deg)' : 'none',
        pillBg: d.rev ? 'rgba(215,182,232,0.12)' : 'rgba(127,209,168,0.12)',
        pillColor: d.rev ? '#D7B6E8' : '#9FE0BF',
        pillBorder: d.rev ? 'rgba(215,182,232,0.4)' : 'rgba(127,209,168,0.4)',
        aria: position + ': ' + displayName + ', ' + (d.rev ? msg('reversed', null, 'reversed') : msg('upright', null, 'upright')) + '. ' + localizeAnswerText(contextual || traditional, picks),
        loading: i === 0 ? 'eager' : 'lazy',
        fetchPriority: i === 0 ? 'high' : 'auto',
        delay: (i * 90) + 'ms'
      };
    });
    var limitedSummary = resultCards.length
      ? msg('limitedSequenceIntro', null, 'The sequence in your new draw:') + ' ' + resultCards.slice(0, 3).map(function (card) {
        var meaning = sentenceFragment(card.traditionalMeaning);
        return msg('limitedSequenceItem', { position: card.pos, name: card.name, orientation: card.orient, meaning: meaning }, card.pos + ': ' + card.name + ' (' + card.orient + ') — ' + meaning);
      }).join('; ') + '. ' + msg('limitedSequenceClose', null, 'The cards show the visible situation, the influence beneath it and where change would need to become visible. Today’s personalized reading remains with the saved spread.')
      : '';
    var meaningSequence = resultCards.length
      ? msg('meaningSequenceIntro', null, 'Your cards’ meaning sequence:') + ' ' + resultCards.slice(0, 3).map(function (card) {
        return card.pos + ': ' + card.name + ' (' + card.orient + ') — ' + sentenceFragment(card.traditionalMeaning) + '.';
      }).join(' ')
      : '';

    var selectedIntent = intentConfig();
    var hasIntent = Boolean(selectedIntent);
    var ti = tierIndex();
    var recommendedTier = selectedIntent ? selectedIntent.tier : C.rec;
    var pricingTiers = Array.isArray(s.pricing.tiers) ? s.pricing.tiers : [];
    function pricingTier(index) {
      var expected = RAIL_TIERS[index];
      return pricingTiers.find(function (item) { return item && item.tier === expected; }) || null;
    }
    function priceFor(index) {
      var quote = pricingTier(index);
      if (!quote || !quote.available) return '';
      if (s.pricing.status === 'ready' && quote.formatted_price) {
        return I18N && typeof I18N.formatMoney === 'function'
          ? I18N.formatMoney(quote.price_minor, s.pricing.currency, quote.formatted_price)
          : quote.formatted_price;
      }
      return s.pricing.status === 'fallback_ready' ? msg('priceCheckout', null, 'Price in secure checkout') : '';
    }
    var offerTiers = TIERS.map(function (tier, index) { return Object.assign({}, tier, I18N && I18N.offerTier ? I18N.offerTier(index) : {}); });
    var tiers = offerTiers.map(function (t, i) {
      var rec = i === recommendedTier, sel = i === ti, price = priceFor(i), usable = pricingCheckoutReady() && !!price;
      var checkoutOff = s.checkoutBusy || !usable;
      return { name: t.base,
        index: i,
        className: 'ft-tier-card ' + (rec ? 'ft-tier-card--recommended' : 'ft-tier-card--alternative') + (sel ? ' is-selected' : '') + (!usable ? ' is-price-pending' : ''),
        sel: sel,
        selLabel: sel ? msg('selectedLevel', null, 'Selected') : msg('selectLevel', null, 'Select this level'),
        selColor: sel ? '#E3C98F' : '#E6E1EC',
        dotBorder: sel ? '#D9BC7E' : 'rgba(243,239,230,0.28)',
        dotFill: sel ? '#D9BC7E' : 'transparent',
        sub: t.base + ' · ' + t.tag,
        price: price || (s.pricing.status === 'error' ? msg('unavailable', null, 'Unavailable') : msg('checking', null, 'Checking…')), priceReady: usable,
        promise: t.promise, cta: s.checkoutBusy ? msg('openingCheckout', null, 'Opening secure checkout…') : (usable ? t.cta + ' · ' + price : msg('checkingSecurePrice', null, 'Checking secure price…')), words: t.words, rec: rec,
        checkoutOff: checkoutOff, checkoutBusy: String(s.checkoutBusy || !usable),
        bullets: t.bullets.map(function (b) { return { t: b }; }),
        bg: (rec || sel) ? '#262235' : '#1D1A28',
        border: sel ? 'rgba(217,188,126,0.8)' : (rec ? 'rgba(217,188,126,0.45)' : 'rgba(243,239,230,0.14)'),
        shadow: sel ? '0 26px 56px rgba(77,52,31,0.17), 0 0 0 1px rgba(185,133,52,0.3)' : (rec ? '0 20px 44px rgba(77,52,31,0.14)' : '0 12px 28px rgba(77,52,31,0.09)'),
        lift: (rec && wide) ? 'translateY(-10px)' : 'none',
        ctaBg: sel ? '#D9BC7E' : 'transparent',
        ctaColor: sel ? '#1A1408' : '#E3C98F',
        ctaBorder: sel ? '#D9BC7E' : 'rgba(217,188,126,0.5)' };
    });
    var tierChoiceLabels = [msg('quickAnswer', null, 'Quick answer'), msg('bestValue', null, 'Best value'), msg('mostComplete', null, 'Most complete')];
    var tierChoices = offerTiers.map(function (t, i) {
      var rec = i === recommendedTier, sel = i === ti, price = priceFor(i), usable = pricingCheckoutReady() && !!price;
      return {
        className: 'ft-tier-choice' + (rec ? ' is-recommended' : '') + (sel ? ' is-selected' : '') + (!usable ? ' is-price-pending' : ''),
        index: i, selected: String(sel), rec: rec,
        label: tierChoiceLabels[i], tag: t.tag, price: price || (s.pricing.status === 'error' ? msg('unavailable', null, 'Unavailable') : msg('checking', null, 'Checking…'))
      };
    });
    var selectedPrice = priceFor(ti);
    var selectedPriceReady = pricingCheckoutReady() && !!selectedPrice;
    var offerCanRetry = s.pricing.status === 'error' && s.pricing.retryable;
    var offerCheckoutOff = s.checkoutBusy || (!selectedPriceReady && !offerCanRetry);
    var pricePendingLabel = s.pricing.status === 'error'
      ? msg('unavailable', null, 'Unavailable')
      : msg('checking', null, 'Checking…');
    var offerCta = s.checkoutBusy
      ? msg('openingCheckout', null, 'Opening secure checkout…')
      : (selectedPriceReady
        ? (I18N && I18N.offerText ? I18N.offerText('continue') : 'Continue to secure checkout') + ' · ' + selectedPrice
        : (offerCanRetry ? msg('retryPrice', null, 'Retry secure price check')
          : (s.pricing.status === 'error' ? msg('checkoutUnavailable', null, 'Checkout temporarily unavailable') : msg('checkingSecurePrice', null, 'Checking secure price…'))));

    var faqDefs = [
      ['Is the free reading really free?', 'Yes. You draw your cards, see every card and receive one personalized pattern signal in a rolling 24-hour window without an account or payment card. An optional paid reading adds a fuller interpretation and practical actions based on the same question and cards.'],
      ['What do I get with a personalized reading?', 'A written reading by email, built around the exact question and cards from this session. The level you choose decides how far it goes: the answer, the deciding condition and timing, or a full comparison of both paths with a 30-day map.'],
      ['How long does delivery take?', 'Your paid reading is generated with AI from your question and selected cards, with automated quality checks. It is delivered by email and on your secure reading page, usually within 90 minutes; extra checks can take up to 24 hours.'],
      ['Do you keep my question?', 'Your question stays attached to your reading and is never sent to analytics or advertising services. You can request deletion at any time.'],
      ['Can I ask about another person?', 'You can ask about a situation that involves someone else, and the reading describes the dynamic as your cards reflect it. It does not claim access to another person’s private thoughts.'],
      ['Is this a subscription?', 'No. Every reading is a one-time purchase, and nothing is stored for future billing.']
    ];
    var faqs = faqDefs.map(function (f, i) {
      return { q: f[0], a: f[1], open: s.faq === i, tf: s.faq === i ? 'rotate(45deg)' : 'none' };
    });

    var canReveal = s.picked.length === needN;
    var isResult = s.phase === 'result';
    var answerStatus = s.server && s.server.status ? s.server.status : (isResult ? 'loading' : 'idle');
    var hasAnswer = isResult && answerStatus === 'ready' && resultCards.length > 0;
    var openQuestion = hasAnswer && preview ? openQuestionText(localizeAnswerText(preview.unresolvedQuestion, picks)) : '';
    var intents = INTENTS.map(function (item, index) {
      var on = item.id === s.intent;
      return {
        id: item.id, number: item.number, title: item.title,
        detail: C.locked[index] || item.detail, on: String(on),
        className: 'ft-intent-option' + (on ? ' is-selected' : ''),
        check: on ? '✓' : ''
      };
    });

    return {
      isAsk: s.phase === 'ask', isChamber: s.phase === 'chamber', isResult: isResult,
      inFlow: s.phase !== 'ask', wide: wide, mob: mob,
      quotaUsed: quotaActive(), quotaAvailable: true, quotaRetryLabel: quotaLabel(),
      entitlementChecking: s.entitlementStatus === 'checking',
      draftAvailable: s.phase === 'ask' && !!s.draft && !s.q,
      draftLabel: s.draft ? msg('restoreDraft', { question: s.draft.slice(0, 58) + (s.draft.length > 58 ? '…' : '') }, 'Restore previous question · ' + s.draft.slice(0, 58) + (s.draft.length > 58 ? '…' : '')) : '',
      resumeAvailable: s.resumeAvailable,
      resumeOtherLanguageAvailable: s.resumeOtherLanguageAvailable,
      resumeOtherLanguageLabel: s.resumeOtherLanguageAvailable
        ? msg('viewSavedInLanguage', { language: I18N && typeof I18N.languageName === 'function' ? I18N.languageName(s.resumeOtherLanguage) : s.resumeOtherLanguage.toUpperCase() }, 'View today’s reading in ' + s.resumeOtherLanguage.toUpperCase())
        : '',
      navVisible: s.phase === 'ask' && wide,
      deckArt: mob ? 'none' : 'flex',
      chipsWrap: 'wrap',
      chipsOverflow: 'visible',
      chipsPad: '0px',
      asidePos: wide ? 'sticky' : 'static',
      sheetAlign: mob ? 'flex-end' : 'center',
      sheetPad: mob ? '0px' : '20px',
      sheetRadius: mob ? '24px 24px 0 0' : '24px',
      barVisible: isResult && selectedPriceReady,
      rootPad: '0px',
      stepLabel: mob
        ? (s.phase === 'chamber' ? '02 / 03' : '03 / 03')
        : (s.phase === 'chamber' ? msg('stepDrawCards', null, 'Step 2 of 3 · Draw your cards') : msg('stepReading', null, 'Step 3 of 3 · Your reading')),
      live: s.live,
      handoffActive: !!s.handoff,
      handoffName: s.handoff ? s.handoff.name : '',
      handoffMeta: s.handoff ? msg('handoffMeta', { n: SP.n }, SP.n + (SP.n === 1 ? ' card' : ' cards') + ' · exact positions preserved from the spreads guide') : '',
      q: s.q, qErr: s.qErr, qInvalid: String(s.qErr), qDescribedBy: s.qErr ? 'ft-topic-help ft-question-error' : 'ft-topic-help', placeholder: C.ph,
      drawBusy: s.drawBusy,
      drawWaiting: s.drawBusy || (!s.cat && s.q.trim().length < MIN_QUESTION_LENGTH),
      drawOff: s.drawBusy,
      quickDrawLabel: s.drawBusy ? msg('preparingCards', null, 'Preparing your cards…') : (s.q.trim() ? msg('drawCards', null, 'Draw My Cards') : msg('drawGeneral', null, 'Draw a General Reading')),
      drawCtaLabel: s.drawBusy ? msg('preparingCards', null, 'Preparing your cards…') : msg('drawCards', null, 'Draw My Cards'),
      generalDrawLabel: s.drawBusy ? msg('preparingCards', null, 'Preparing your cards…') : msg('drawGeneralThree', null, 'No specific question? Draw a general three-card reading'),
      drawStatus: s.drawBusy ? msg('loadingDeckSafe', null, 'Loading the complete 78-card deck. Your question is safe.') : s.drawError,
      charCount: questionCount(),
      cats: cats, examples: examples, spreads: spreads, sheet: s.sheet,
      spreadName: SP.name,
      spreadPositions: SP.pos.join(' · '),
      spreadMeta: SP.n + ' ' + msg(SP.n === 1 ? 'card' : 'cards', null, SP.n === 1 ? 'card' : 'cards') + ' · ' + durationLabel(SP.time) + ' · ' + (s.handoff ? msg('selectedGuide', null, 'Selected in the Tarot Spreads guide') : C.why),
      deckCards: deckCards,
      chooseLine: msg('chooseReady', { n: needN }, 'Choose ' + needN + (needN === 1 ? ' card' : ' cards') + ' when you feel ready.'),
      qEcho: '“' + (s.q || C.general) + '”',
      countText: canReveal
        ? msg('readyReveal', { n: needN }, needN + ' of ' + needN + ' selected · ready to reveal')
        : (s.picked.length
          ? msg('selectedMore', { selected: s.picked.length, total: needN, left: needN - s.picked.length }, s.picked.length + ' of ' + needN + ' selected · choose ' + (needN - s.picked.length) + ' more')
          : msg('chooseAbove', { n: needN }, 'Choose ' + needN + (needN === 1 ? ' card' : ' cards') + ' above to continue')),
      countColor: canReveal ? '#E3C98F' : '#E6E1EC',
      revealOff: !canReveal,
      revealLabel: canReveal ? msg('revealReading', null, 'Reveal My Reading') : msg('selectMore', { n: needN - s.picked.length }, 'Select ' + (needN - s.picked.length) + ' more ' + ((needN - s.picked.length) === 1 ? 'card' : 'cards')),
      revealCursor: 'pointer',
      revealBg: canReveal ? '#D9BC7E' : 'transparent',
      revealColor: canReveal ? '#1A1408' : '#E6E1EC',
      revealBorder: canReveal ? '#D9BC7E' : '#3A3450',
      resultCards: resultCards,
      cardCol: mob ? 'min(82vw,320px)' : (wide && needN <= 5 ? 'minmax(0,1fr)' : (needN > 5 ? 'minmax(min(148px,58vw),1fr)' : 'minmax(min(214px,74vw),1fr)')),
      resultAdvanceVisible: !wide || needN > 5,
      resultRailLabel: wide && needN <= 5 ? msg('railAll', null, 'Your revealed tarot cards. All cards are visible.') : msg('railSwipe', null, 'Your revealed tarot cards. Swipe horizontally to review every card.'),
      resultSwipeHint: (Math.min(s.resultIndex + 1, needN) || 1) + ' / ' + needN,
      resultActionLabel: s.resultIndex >= needN - 1 ? msg('readingOptions', null, 'See your reading') : msg('nextCard', null, 'Next card'),
      hasAnswer: hasAnswer,
      answerLoading: isResult && answerStatus === 'loading',
      answerLimited: isResult && answerStatus === 'limited',
      limitedHeading: s.server && s.server.limitScope === 'service_capacity' ? msg('capacityLimitHeading', null, 'Today’s free personalized preview capacity is full') : msg('dailyLimitHeading', null, 'Today’s personalized free insight has already been used'),
      limitedExplanation: s.server && s.server.limitScope === 'service_capacity' ? msg('capacityLimitBody', null, 'You can review your cards and meanings, or continue with an optional written reading.') : msg('dailyLimitExplanation', { time: quotaLabel() }, 'A new personalized free insight opens ' + quotaLabel() + '. You can still review the traditional meanings in this spread or continue with an optional written reading below.'),
      answerError: isResult && answerStatus === 'error',
      limitedSummary: limitedSummary,
      freeAnswer: hasAnswer ? (preview ? localizeAnswerText(preview.recognition, picks) : msg('patternFallback', { cards: resultCards.slice(0, 3).map(function (card) { return card.name; }).join(', ') }, 'Your spread brings together ' + resultCards.slice(0, 3).map(function (card) { return card.name; }).join(', ') + '. The card meanings below describe the themes in this draw.')) : '',
      freeMeaningSequence: hasAnswer ? meaningSequence : '',
      freeTension: '',
      freeUnresolvedQuestion: openQuestion,
      hasUnresolvedQuestion: !!openQuestion,
      hasStructuredPreview: false,
      followup: s.followup,
      followupCount: followupCount(),
      essentialName: offerTiers[0].base, focusedName: offerTiers[1].base, indepthName: offerTiers[2].base,
      essentialSummary: offerTiers[0].promise, focusedSummary: offerTiers[1].promise, indepthSummary: offerTiers[2].promise,
      selectedPackageName: offerTiers[ti].base, selectedPackageSummary: offerTiers[ti].promise,
      essentialPriceLabel: priceFor(0) || pricePendingLabel,
      focusedPriceLabel: priceFor(1) || pricePendingLabel,
      indepthPriceLabel: priceFor(2) || pricePendingLabel,
      focusedSelected: ti === 1,
      indepthSelected: ti === 2,
      resultCardCount: needN + ' ' + msg(needN === 1 ? 'card' : 'cards', null, needN === 1 ? 'card' : 'cards'),
      offerCta: offerCta,
      offerCanRetry: offerCanRetry,
      offerCheckoutOff: offerCheckoutOff,
      hasIntent: hasIntent,
      intents: intents,
      categorySourceLabel: s.handoff ? msg('carried', null, 'Carried from spreads guide') : (s.cat ? msg('selectedFocus', null, 'Selected focus') : msg('recognizedFocus', null, 'Recognized focus')),
      categoryDisplay: categoryDisplay(catKey),
      categoryDescription: s.handoff ? (SP.name + ' kept all ' + SP.n + ' positions you selected before drawing.') : (s.cat ? C.focus : C.why.replace(/^This reads as /, 'Your question is being read as ')),
      selectedIntentTitle: selectedIntent ? selectedIntent.title : '',
      selectedIntentQuestion: selectedIntent ? (C.locked[INTENTS.indexOf(selectedIntent)] || selectedIntent.detail) : '',
      locked: C.locked.map(function (t) { return { t: t }; }),
      startingPriceLabel: s.pricing.status === 'fallback_ready' ? msg('priceConfirmed', null, 'price confirmed in secure checkout') : (priceFor(1) || (s.pricing.status === 'error' ? msg('temporarilyUnavailable', null, 'temporarily unavailable') : msg('priceLoading', null, 'price is loading…'))),
      decisionPriceLabel: priceFor(1) || msg('focused', null, 'Focused'),
      recCta: offerCta,
      tiers: tiers,
      primaryTiers: tiers.filter(function (tier) { return tier.index === 1; }),
      alternativeTiers: tiers.filter(function (tier) { return tier.index !== 1; }),
      tierChoices: tierChoices,
      pricingHeading: msg('pricingHeading', null, 'Your decision reading'),
      pricingVisible: false,
      pricingLoading: false,
      pricingError: false,
      pricingRetryable: false,
      pricingErrorText: s.pricing.error_code === 'product_contract_unavailable' ? msg('productUnavailable', null, 'Personalized reading checkout is temporarily unavailable. We have been notified; your free reading is safe.') : msg('priceUnavailable', null, 'Secure local pricing could not be verified. Retry without losing your reading.'),
      pricingErrorCode: s.pricing.error_code || 'price_unavailable',
      isCheckout: false, isConfirm: false,
      barName: offerTiers[ti].base,
      barMeta: msg('questionAndCardsAttached', null, 'Your question and selected cards stay attached'),
      barCta: s.checkoutBusy ? msg('opening', null, 'Opening…') : (pricingCheckoutReady() && priceFor(ti) ? msg('continue', null, 'Continue') + ' · ' + priceFor(ti) : (s.pricing.status === 'error' ? (s.pricing.retryable ? msg('retryPrice', null, 'Retry secure price check') : msg('checkoutUnavailable', null, 'Checkout temporarily unavailable')) : msg('checkingPrice', null, 'Checking price…'))),
      checkoutOff: offerCheckoutOff, checkoutBusy: String(s.checkoutBusy || s.pricing.status === 'loading'), checkoutInputsOff: String(s.checkoutBusy),
      coCards: '', coLevel: '', coLevelSub: '', coTotal: '', coEmail: '', coName: '', coErr: false,
      emailBorder: 'rgba(243,239,230,0.2)',
      confirmLine: '', upgradeShow: false, upgraded: false,
      upgradeTitle: '', upgradeBody: '', upgradeCta: '', upgradedLine: '',
      faqs: faqs,
      showEditorial: true
    };
  }

  /* ------------ renderer (paylaşılan data-rv2 çekirdeği) ------------ */
  function resolvePath(vals, item, path) {
    if (item != null && typeof item !== 'object' && path.indexOf('.') === -1) return item;
    if (item && path.indexOf('.') > -1) {
      var key = path.split('.').slice(1).join('.');
      var v = item;
      key.split('.').forEach(function (p) { v = v == null ? v : v[p]; });
      if (v !== undefined) return v;
    }
    var out = vals;
    path.split('.').forEach(function (p) { out = out == null ? out : out[p]; });
    return out;
  }
  function applyBindings(scope, vals, item) {
    function skip(el) {
      if (!item && el.closest('[data-rv2-item]')) return true;
      var conditional = el.closest('[data-rv2-if]');
      return Boolean(conditional && conditional.style.display === 'none');
    }
    scope.querySelectorAll('[data-rv2-bind]').forEach(function (el) {
      if (skip(el)) return;
      var v = resolvePath(vals, item, el.getAttribute('data-rv2-bind'));
      var next = v == null ? '' : String(v);
      if (el.textContent !== next) el.textContent = next;
    });
    scope.querySelectorAll('*').forEach(function (el) {
      if (skip(el)) return;
      Array.prototype.slice.call(el.attributes).forEach(function (attr) {
        if (attr.name.indexOf('data-rv2-attr-') !== 0) return;
        var real = attr.name.slice('data-rv2-attr-'.length);
        var value = attr.value.replace(/%%([\w.]+)%%/g, function (_, key) {
          var v = resolvePath(vals, item, key);
          return v == null ? '' : String(v);
        });
        if (real === 'value') { if (el.value !== value) el.value = value; }
        else if (real === 'disabled' || real === 'aria-disabled') {
          if (value && value !== 'false') {
            var enabledValue = real === 'disabled' ? '' : 'true';
            if (el.getAttribute(real) !== enabledValue) el.setAttribute(real, enabledValue);
          } else if (el.hasAttribute(real)) el.removeAttribute(real);
        }
        else if (el.getAttribute(real) !== value) el.setAttribute(real, value);
      });
    });
    scope.querySelectorAll('[data-rv2-ifitem]').forEach(function (el) {
      if (skip(el)) return;
      var key = el.getAttribute('data-rv2-ifitem');
      var neg = key.charAt(0) === '!';
      var v = resolvePath(vals, item, neg ? key.slice(1) : key);
      var display = (neg ? !v : !!v) ? 'contents' : 'none';
      if (el.style.display !== display) el.style.display = display;
    });
    if (item != null) {
      scope.querySelectorAll('[data-rv2-list]').forEach(function (h) {
        var nmr = h.getAttribute('data-rv2-list');
        if (nmr.indexOf('.') === -1) return;
        var sub = resolvePath(vals, item, nmr.replace(/\d+$/, ''));
        if (sub && sub.length) instantiateList(h, sub, vals);
      });
    }
  }
  var TPL = {};
  document.querySelectorAll('[data-ft-scope] template[data-rv2-tpl]').forEach(function (t) {
    TPL[t.getAttribute('data-rv2-tpl')] = t;
  });
  TPL.primaryTiers = TPL.tiers;
  TPL.alternativeTiers = TPL.tiers;
  function instantiateList(host, items, vals) {
    var name = host.getAttribute('data-rv2-list').split('.').pop();
    var tpl = TPL[name] || TPL[name.replace(/\d+$/, '')];
    if (!tpl) return;
    var signature = JSON.stringify(items);
    if (host.__rv2Signature === signature) return;
    host.__rv2Signature = signature;
    if (host.style.display !== 'contents') host.style.display = 'contents';
    while (host.firstChild) host.removeChild(host.firstChild);
    items.forEach(function (item, idx) {
      var node = tpl.content.cloneNode(true);
      var holder = document.createElement('div');
      holder.style.display = 'contents';
      holder.setAttribute('data-rv2-item', name.replace(/\d+$/, ''));
      holder.setAttribute('data-rv2-idx', String(idx));
      holder.appendChild(node);
      applyBindings(holder, vals, item);
      host.appendChild(holder);
    });
  }
  function render() {
    var vals = computeVals();
    document.querySelectorAll('[data-ft-scope]').forEach(function (scope) {
      var conditionals = Array.prototype.slice.call(scope.querySelectorAll('[data-rv2-if]'));
      if (scope.matches('[data-rv2-if]')) conditionals.unshift(scope);
      conditionals.forEach(function (el) {
        if (el.closest('[data-rv2-item]')) return;
        var key = el.getAttribute('data-rv2-if');
        var neg = key.charAt(0) === '!';
        var v = vals[neg ? key.slice(1) : key];
        var display = (neg ? !v : !!v) ? 'contents' : 'none';
        if (el.style.display !== display) el.style.display = display;
      });
      scope.querySelectorAll('[data-rv2-list]').forEach(function (host) {
        if (host.closest('[data-rv2-item]')) return;
        var conditional = host.closest('[data-rv2-if]');
        if (conditional && conditional.style.display === 'none') return;
        var name = host.getAttribute('data-rv2-list');
        instantiateList(host, vals[name] || vals[name.replace(/\d+$/, '')] || [], vals);
      });
      applyBindings(scope, vals, null);
      scope.querySelectorAll('input[data-ft-package-choice]').forEach(function (input) {
        var selected = Number(input.value) === tierIndex();
        input.checked = selected;
        input.tabIndex = selected ? 0 : -1;
      });
    });
    observeFunnelVisibility();
    if (document.body) {
      document.body.classList.toggle('ft-has-sticky-offer', vals.barVisible);
      document.body.classList.toggle('ft-result-open', vals.isResult);
    }
    persistState();
  }
  function renderChamberSelection() {
    var chamber = document.querySelector('[data-screen-label="Reading chamber"]');
    if (!chamber || s.phase !== 'chamber') {
      render();
      return;
    }
    var vals = computeVals();
    var host = chamber.querySelector('[data-rv2-list="deckCards"]');
    if (host) instantiateList(host, vals.deckCards || [], vals);
    applyBindings(chamber, vals, null);
    persistState();
  }

  /* ------------ helpers ------------ */
  function visitorId() {
    var key = 'deckaura_visitor_v1';
    try {
      var existing = localStorage.getItem(key);
      if (existing && /^[a-zA-Z0-9_-]{16,96}$/.test(existing)) return existing;
      var bytes = new Uint8Array(18); crypto.getRandomValues(bytes);
      var next = 'v_' + Array.prototype.map.call(bytes, function (x) { return x.toString(16).padStart(2, '0'); }).join('');
      localStorage.setItem(key, next);
      return next;
    } catch (_) { return 'v_' + Date.now().toString(16) + Math.random().toString(36).slice(2, 10); }
  }
  function readQuotaExpiry() {
    try {
      var saved = JSON.parse(localStorage.getItem(QUOTA_KEY) || 'null');
      var expiry = Number(saved && saved.expiresAt) || 0;
      if (expiry > Date.now() && expiry - Date.now() <= QUOTA_WINDOW_MS + (5 * 60 * 1000)) return expiry;
      localStorage.removeItem(QUOTA_KEY);
    } catch (_) {}
    return 0;
  }
  function quotaExpiryFromResponse(data, retryAfter, consumed) {
    var free = data && data.freeReadings || {};
    var entitlement = data && data.entitlement || {};
    var raw = entitlement.nextAt || free.nextAt || free.resetAt || data && (data.nextAt || data.resetAt);
    var numeric = Number(raw);
    var parsed = Number.isFinite(numeric) && numeric > 0 ? (numeric < 100000000000 ? numeric * 1000 : numeric) : (raw ? Date.parse(raw) : 0);
    if (Number.isFinite(parsed) && parsed > Date.now()) return parsed;
    var seconds = Number(retryAfter);
    if (Number.isFinite(seconds) && seconds > 0) return Date.now() + Math.min(seconds * 1000, QUOTA_WINDOW_MS);
    var retryDate = retryAfter ? Date.parse(retryAfter) : 0;
    if (Number.isFinite(retryDate) && retryDate > Date.now()) return Math.min(retryDate, Date.now() + QUOTA_WINDOW_MS);
    return consumed ? Date.now() + QUOTA_WINDOW_MS : Date.now() + (30 * 60 * 1000);
  }
  function rememberQuota(data, retryAfter, consumed) {
    quotaExpiresAt = quotaExpiryFromResponse(data, retryAfter, consumed);
    /* The published API does not expose a resume endpoint. Keep the rolling
       entitlement accurate without presenting a recovery action that 404s. */
    s.resumeToken = '';
    s.resumeAvailable = false;
    s.resumeOtherLanguage = '';
    s.resumeOtherLanguageAvailable = false;
    try { localStorage.removeItem(RESUME_KEY); } catch (_) {}
    try { localStorage.setItem(QUOTA_KEY, JSON.stringify({ expiresAt: quotaExpiresAt, savedAt: Date.now() })); } catch (_) {}
  }
  function quotaActive() {
    if (quotaExpiresAt > Date.now()) return true;
    if (quotaExpiresAt) {
      quotaExpiresAt = 0;
      try { localStorage.removeItem(QUOTA_KEY); } catch (_) {}
    }
    return false;
  }
  function quotaLabel() {
    if (!quotaActive()) return msg('now', null, 'now');
    var remaining = Math.max(0, quotaExpiresAt - Date.now());
    var totalMinutes = Math.max(1, Math.ceil(remaining / 60000));
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;
    if (hours && minutes) return msg('inHoursMinutes', { h: hours, m: minutes }, 'in ' + hours + 'h ' + minutes + 'm');
    if (hours) return msg('inHours', { h: hours }, 'in ' + hours + 'h');
    return msg('inMinutes', { m: minutes }, 'in ' + minutes + 'm');
  }
  function restoreResumeCache() {
    s.resumeToken = '';
    s.resumeAvailable = false;
    s.resumeOtherLanguage = '';
    s.resumeOtherLanguageAvailable = false;
    try { localStorage.removeItem(RESUME_KEY); } catch (_) {}
  }
  function checkEntitlement() {
    /* The currently published API exposes answer/health but not status/resume.
       Keep the local 24-hour gate authoritative until that optional endpoint ships. */
    s.entitlementStatus = 'ready';
    render();
    return Promise.resolve(null);
  }
  function resumeLastReading() {
    if (!/^[a-f0-9]{32}$/.test(String(s.resumeToken || ''))) return false;
    s.live = msg('restoring', null, 'Restoring today’s reading…');
    publishFunnelEvent('quota_resume_opened', { source: 'quota_status' });
    fetch(API_BASE + '/resume', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({ visitorId: visitorId(), resumeToken: s.resumeToken }, localePayload()))
    }).then(function (response) { return response.json().then(function (data) { return { ok: response.ok, data: data }; }); })
      .then(function (result) {
        if (!result.ok || !result.data || !result.data.preview) throw new Error(result.data && result.data.error === 'resume_locale_mismatch' ? 'resume_locale_mismatch' : 'resume_unavailable');
        var data = result.data;
        var cards = Array.isArray(data.cards) ? data.cards : [];
        var all = deckData() || [];
        var rebuilt = cards.map(function (entry) {
          var card = all.find(function (candidate) { return candidate.name === entry.name; });
          return card ? { card: card, rev: entry.orientation === 'reversed' || entry.reversed === true } : null;
        }).filter(Boolean);
        if (!SPREADS[data.spread] || rebuilt.length !== SPREADS[data.spread].n) throw new Error('resume_evidence_invalid');
        cancelAnswerRequest();
        setComposerValue(data.question);
        s.cat = CATS[data.category] ? data.category : detect(s.q);
        s.spread = data.spread;
        s.positions = savedPositions(cards.map(function (entry) { return entry.position; }), true);
        s.deck = rebuilt;
        s.picked = rebuilt.map(function (_card, index) { return index; });
        s.readingId = String(data.readingId || uuid('r_'));
        s.server = { status: 'ready', preview: data.preview, answer: String(data.answer || ''), previewVersion: data.previewVersion || '', promptVersion: data.promptVersion || '', nextAt: Number(data.expiresAt) || quotaExpiresAt };
        s.phase = 'result'; s.intent = DEFAULT_INTENT_ID; s.tier = 1; s.resultIndex = 0; s.live = msg('restored', null, 'Today’s reading has been restored.');
        render();
        enableRail();
        window.setTimeout(function () { scrollScreen('Free result', 70); }, 60);
      }).catch(function (error) {
        s.resumeAvailable = false; s.resumeToken = ''; s.live = error && error.message === 'resume_locale_mismatch'
          ? msg('localeMismatch', null, 'Today’s saved reading was created in a different language and was not opened here.')
          : msg('restoreFailed', null, 'Today’s saved reading could not be restored. You can still draw cards or continue with a paid reading.');
        try { localStorage.removeItem(RESUME_KEY); } catch (_) {}
        render();
      });
    return true;
  }
  function resumeOtherLanguageReading() {
    var route = languageRoute(s.resumeOtherLanguage);
    if (!route) return false;
    publishFunnelEvent('quota_resume_opened', { source: 'other_language', reading_language: s.resumeOtherLanguage });
    window.location.assign(route + '?resume=1');
    return true;
  }
  function canonicalizeAnswerCardNames(answer, picks) {
    var text = String(answer || '').trim();
    var names = (picks || []).map(function (pick) { return String(pick && pick.card && pick.card.name || ''); }).filter(Boolean);
    if (!text || !names.length) return text;
    var ranks = 'Ace|Two|Three|Four|Five|Six|Seven|Eight|Nine|Ten|Page|Knight|Queen|King';
    var valid = {};
    names.forEach(function (name) { valid[name.toLowerCase()] = name; });
    return text.replace(new RegExp('\\b(' + ranks + ') of ([A-Za-z]+)\\b', 'g'), function (phrase, rank) {
      if (valid[phrase.toLowerCase()]) return valid[phrase.toLowerCase()];
      var matches = names.filter(function (name) { return name.indexOf(rank + ' of ') === 0; });
      return matches.length === 1 ? matches[0] : phrase;
    });
  }
  function scrollScreen(label, offset) {
    var el = document.querySelector('[data-screen-label="' + label + '"]');
    if (!el) return;
    try {
      window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - (offset || 76), behavior: 'smooth' });
    } catch (_) {}
  }
  function activeTab() { return !document.hidden && document.visibilityState !== 'hidden'; }
  function scheduleVisibilityEvent(el, name) {
    var key = (s.attemptId || 'page') + ':' + name;
    if (seenMilestones[key] || visibilityTimers[key]) return;
    visibilityTimers[key] = window.setTimeout(function check() {
      if (!el.isConnected || !el.__ftHalfVisible) { delete visibilityTimers[key]; return; }
      if (!activeTab() || (name === 'free_result_viewed' && (!s.server || s.server.status === 'loading'))) {
        visibilityTimers[key] = window.setTimeout(check, 250);
        return;
      }
      delete visibilityTimers[key];
      if (publishFunnelEvent(name, { spread: spreadKey(), category: cat() }, { once: true })) seenMilestones[key] = true;
    }, 1000);
  }
  function cancelPrimaryCtaView() {
    if (primaryCtaViewTimer) window.clearTimeout(primaryCtaViewTimer);
    primaryCtaViewTimer = 0;
    primaryCtaView = null;
  }
  function primaryCtaViewFingerprint(el) {
    if (!el || !el.isConnected || !el.__ftHalfVisible || !activeTab() || el.disabled || el.getAttribute('aria-disabled') === 'true' || el.getAttribute('aria-busy') === 'true') return '';
    if (s.phase !== 'result' || !s.attemptId || !s.readingId || !s.server || s.server.status === 'loading' || s.checkoutBusy || !pricingCheckoutReady()) return '';
    var tier = RAIL_TIERS[tierIndex()];
    var quote = (s.pricing.tiers || []).find(function (item) { return item.tier === tier; });
    if (!quote || !quote.available || (s.pricing.status === 'ready' && !quote.formatted_price)) return '';
    var rect = el.getBoundingClientRect();
    var style = window.getComputedStyle(el);
    if (!rect.width || !rect.height || style.visibility !== 'visible' || style.display === 'none' || Number(style.opacity) === 0) return '';
    if (typeof el.checkVisibility === 'function' && !el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true })) return '';
    var visibleWidth = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
    var visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
    if (visibleWidth * visibleHeight / (rect.width * rect.height) < 0.5) return '';
    return JSON.stringify([s.attemptId, s.readingId, tier, s.pricing.status, s.pricing.source, s.pricing.currency, quote.variant_id, quote.price_minor, quote.formatted_price, el.textContent]);
  }
  function schedulePrimaryCtaView(el) {
    var key = s.attemptId + ':paid_primary_cta_viewed';
    var fingerprint = primaryCtaViewFingerprint(el);
    if (!fingerprint || seenMilestones[key] || s.sentEvents[key]) { cancelPrimaryCtaView(); return; }
    if (primaryCtaView && primaryCtaView.el === el && primaryCtaView.fingerprint === fingerprint) return;
    cancelPrimaryCtaView();
    var view = primaryCtaView = { el: el, fingerprint: fingerprint, started: performance.now() };
    primaryCtaViewTimer = window.setTimeout(function check() {
      if (primaryCtaView !== view) return;
      primaryCtaViewTimer = 0;
      if (primaryCtaViewFingerprint(el) !== view.fingerprint) { cancelPrimaryCtaView(); schedulePrimaryCtaView(el); return; }
      if (performance.now() - view.started < 1000) { primaryCtaViewTimer = window.setTimeout(check, 100); return; }
      cancelPrimaryCtaView();
      if (publishFunnelEvent('paid_primary_cta_viewed', { tier: RAIL_TIERS[tierIndex()], category: cat() }, { once: true })) seenMilestones[key] = true;
    }, 100);
  }
  function observeFunnelVisibility() {
    if (!('IntersectionObserver' in window)) return;
    if (!milestoneObserver) {
      milestoneObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.__ftHalfVisible = entry.isIntersecting && entry.intersectionRatio >= 0.5;
          if (entry.target.matches('[data-rv2-act="offeropen"]')) { schedulePrimaryCtaView(entry.target); return; }
          var name = entry.target.getAttribute('data-ft-view-event');
          if (name === 'free_result_viewed') engagedVisible = entry.target.__ftHalfVisible;
          if (entry.target.__ftHalfVisible && name) scheduleVisibilityEvent(entry.target, name);
        });
      }, { threshold: [0, 0.5, 1] });
      document.addEventListener('visibilitychange', function () { schedulePrimaryCtaView(primaryCtaObserved); });
      window.addEventListener('pagehide', cancelPrimaryCtaView);
      window.addEventListener('pageshow', function () { schedulePrimaryCtaView(primaryCtaObserved); });
      engagedLastTick = Date.now();
      engagedTimer = window.setInterval(function () {
        var now = Date.now();
        if (engagedVisible && activeTab() && s.attemptId && s.server && s.server.status !== 'loading') {
          engagedMs += Math.min(1000, now - engagedLastTick);
          if (engagedMs >= 10000) publishFunnelEvent('free_result_engaged', { spread: spreadKey(), category: cat() }, { once: true });
        }
        engagedLastTick = now;
      }, 500);
    }
    document.querySelectorAll('[data-ft-view-event]').forEach(function (el) {
      if (!el.__ftObserved) { el.__ftObserved = true; milestoneObserver.observe(el); }
    });
    var primary = document.querySelector('[data-ft-scope] [data-rv2-act="offeropen"]');
    if (primary !== primaryCtaObserved) {
      cancelPrimaryCtaView();
      if (primaryCtaObserved) milestoneObserver.unobserve(primaryCtaObserved);
      if (primaryCtaMutationObserver) primaryCtaMutationObserver.disconnect();
      primaryCtaObserved = primary;
      if (primary) {
        milestoneObserver.observe(primary);
        if (typeof MutationObserver === 'function') {
          primaryCtaMutationObserver = new MutationObserver(function () { schedulePrimaryCtaView(primaryCtaObserved); });
          primaryCtaMutationObserver.observe(primary, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'hidden', 'style', 'class'], childList: true, characterData: true, subtree: true });
        }
      }
    }
    schedulePrimaryCtaView(primary);
  }
  function goIntent() {
    var el = document.getElementById('ft-intent');
    if (!el) return;
    try { window.scrollTo({ top: el.getBoundingClientRect().top + window.pageYOffset - 82, behavior: 'smooth' }); } catch (_) {}
  }
  function focusComposer() {
    var q = document.querySelector('textarea[data-rv2-question]');
    if (!q) return;
    try { q.scrollIntoView({ block: 'center', behavior: 'smooth' }); q.focus({ preventScroll: true }); } catch (_) {}
  }
  /* Crisis wording is classified by the shared guard (assets/deckaura-crisis-guard.js, loaded by sections/ft-hero.liquid
     before this file): the visitor gets the localized support message instead of a reading or a checkout, and the text
     is not kept in this tab's storage. Without the guard nothing is screened here; the reading service's
     *_SAFETY_BLOCKED refusal is the backstop and also shows the support message. */
  function crisisUrgent(text) {
    var cached = storageScreenCache.find(function (entry) { return entry.text === text; });
    if (cached) return cached.urgent;
    var g = window.DeckauraCrisisGuard;
    if (!g || typeof g.classify !== 'function' || !String(text || '').trim()) return false;
    try { return g.classify(text).kind === 'urgent'; } catch (_) { return false; }
  }
  function supportCopy(kind) {
    var g = window.DeckauraCrisisGuard;
    try {
      var m = g && typeof g.message === 'function' ? g.message(kind === 'blocked' ? 'blocked' : 'urgent', document.documentElement.lang || FT_LOCALE) : '';
      if (m) return m;
    } catch (_) {}
    return msg('checkoutSupport', null, 'We can’t turn what you wrote into a tarot reading. If you are in danger, call your local emergency number or a crisis line now.');
  }
  function showQuestionSupport(message) {
    var node = document.querySelector('[data-ft-question-support]');
    if (!node) return;
    node.textContent = message || '';
    node.hidden = !message;
  }
  function railHoldsForSafety() {
    try {
      var api = window.DeckauraDeepReading;
      return !!api && typeof api.getRiskKind === 'function' && api.getRiskKind() === 'urgent';
    } catch (_) { return false; }
  }
  /* The support message in the package area: near-white on the dark panel, no retry link, no "try again". */
  function checkoutSupport(kind) {
    s.checkoutQueued = false;
    s.checkoutVia = '';
    s.checkoutBusy = false;
    render();
    var st = document.querySelector('[data-rv2-checkout-status]');
    if (!st) return;
    st.textContent = supportCopy(kind);
    st.style.display = 'block';
    st.style.color = '#F5F0E8';
    checkoutRecovery(false);
  }
  function castStrings() {
    var SP = currentSpread();
    return drawn().map(function (d, i) {
      return SP.pos[i] + ': ' + d.card.name + ' ' + (d.rev ? 'Reversed' : 'Upright');
    }).join('; ');
  }
  function followupCount() {
    return msg('optionalCharacterCount', { n: s.followup.length }, 'Optional · ' + s.followup.length + ' / 240');
  }
  function questionCount() {
    return msg('questionCharacterCount', { n: s.q.length, min: MIN_QUESTION_LENGTH }, s.q.length + ' / 240 · min. ' + MIN_QUESTION_LENGTH);
  }
  function checkoutQuestions() {
    var original = String(s.q || '').trim() || CATS[cat()].general;
    var followup = String(s.followup || '').trim();
    return {
      original: original,
      followup: followup,
      // A short optional note stays in the context without replacing the original question.
      selected: followup.length >= 8 ? followup : original
    };
  }
  function setComposerValue(value) {
    s.q = String(value || '').slice(0, 240);
    var composer = document.querySelector('textarea[data-rv2-question]');
    if (composer && composer.value !== s.q) composer.value = s.q;
  }

  function applyPricingSnapshot(snapshot) {
    if (!snapshot || !/^(loading|ready|fallback_ready|error)$/.test(String(snapshot.status || ''))) return;
    var tiers = Array.isArray(snapshot.tiers) ? snapshot.tiers.map(function (item) {
      item = item || {};
      var tier = cleanToken(item.tier, 20);
      return {
        tier: RAIL_TIERS.indexOf(tier) >= 0 ? tier : '',
        variant_id: /^\d{10,20}$/.test(String(item.variant_id || '')) ? String(item.variant_id) : '',
        price_minor: Number.isInteger(Number(item.price_minor)) && Number(item.price_minor) > 0 ? Number(item.price_minor) : null,
        formatted_price: String(item.formatted_price || '').replace(/[<>]/g, '').slice(0, 40),
        available: item.available === true
      };
    }).filter(function (item) { return item.tier; }) : [];
    s.pricing = {
      status: String(snapshot.status),
      source: /^(live|liquid_retained|checkout)$/.test(String(snapshot.source || '')) ? String(snapshot.source) : 'live',
      checkout_allowed: snapshot.checkout_allowed === true,
      retryable: snapshot.retryable === true,
      currency: /^[A-Z]{3}$/.test(String(snapshot.currency || '')) ? String(snapshot.currency) : '',
      latency_ms: Math.max(0, Number(snapshot.latency_ms) || 0),
      error_code: cleanToken(snapshot.error_code || '', 80),
      tiers: tiers
    };
    if (s.pricing.status === 'loading') {
      publishFunnelEvent('price_check_started', { status: 'loading' }, { once: true });
    } else if (s.pricing.status === 'ready') {
      pricingAutoRetryCount = 0;
      if (pricingAutoRetryTimer) { clearTimeout(pricingAutoRetryTimer); pricingAutoRetryTimer = 0; }
      publishFunnelEvent('price_check_succeeded', { status: 'ready', currency: s.pricing.currency, latency_ms: s.pricing.latency_ms }, { once: true });
    } else if (s.pricing.status === 'fallback_ready') {
      pricingAutoRetryCount = 0;
      if (pricingAutoRetryTimer) { clearTimeout(pricingAutoRetryTimer); pricingAutoRetryTimer = 0; }
      publishFunnelEvent('price_check_fallback', { status: 'fallback_ready', source: s.pricing.source, error_code: s.pricing.error_code || 'market_price_fallback', latency_ms: s.pricing.latency_ms }, { once: true });
    } else {
      publishFunnelEvent('price_check_failed', { status: 'error', error_code: s.pricing.error_code || 'price_unavailable', latency_ms: s.pricing.latency_ms }, { once: true });
      if (s.pricing.retryable && pricingAutoRetryCount < 1 && !pricingAutoRetryTimer) {
        pricingAutoRetryCount += 1;
        pricingAutoRetryTimer = window.setTimeout(function () {
          pricingAutoRetryTimer = 0;
          retryPricing();
        }, 1200);
      }
      if (!s.pricing.retryable && s.checkoutQueued) { s.checkoutQueued = false; s.checkoutVia = ''; s.checkoutBusy = false; }
    }
    render();
    showPricingNotice();
  }
  // Say why the package button cannot open checkout, right under it, with the direct reading link.
  function showPricingNotice() {
    if (s.checkoutBusy) return;
    if (s.pricing.status === 'error' && !pricingAutoRetryTimer) {
      checkoutStatus(s.pricing.retryable
        ? msg('priceUnavailable', null, 'Secure local pricing could not be verified. Retry without losing your reading.')
        : msg('priceNotConfirmed', null, 'We could not confirm the secure price for your region right now. Your free reading is safe.'), true);
      pricingNoticeShown = true;
    } else if (pricingNoticeShown && (s.pricing.status === 'ready' || s.pricing.status === 'fallback_ready')) {
      checkoutStatus('', false);
    }
  }

  function waitForCheckoutRail(resolve, reject, startedAt) {
    if (window.DeckauraDeepReading && typeof window.DeckauraDeepReading.enable === 'function') {
      resolve(true);
      return;
    }
    if (Date.now() - startedAt > 5000) {
      reject(new Error('checkout_ui_api_unavailable'));
      return;
    }
    window.setTimeout(function () { waitForCheckoutRail(resolve, reject, startedAt); }, 40);
  }
  function recoverLoadedCheckoutRail() {
    var api = window.DeckauraDeepReading;
    if (s.phase !== 'result' || !s.readingId || !api || typeof api.enable !== 'function') return;
    if (s.pricing.error_code !== 'checkout_ui_load_failed') return;
    var host = document.getElementById('ft-checkout-rail-host');
    if (host) host.setAttribute('data-mounted', 'true');
    s.pricing.status = 'loading';
    s.pricing.error_code = '';
    s.pricing.retryable = false;
    checkoutStatus('', false);
    render();
    enableRail();
  }
  function checkoutRailFailed(error, readingId) {
    if (s.phase !== 'result' || s.readingId !== readingId) return;
    s.pricing.status = 'error';
    s.pricing.error_code = 'checkout_ui_load_failed';
    s.pricing.checkout_allowed = false;
    s.pricing.retryable = true;
    s.checkoutBusy = false;
    s.checkoutQueued = false;
    render();
    checkoutStatus(msg('checkoutLoadFailed', null, 'Secure checkout controls could not load. Your free reading is safe; retry when your connection is stable.'), true);
    publishFunnelEvent('price_check_failed', { status: 'error', error_code: cleanToken(error && error.message || 'checkout_ui_load_failed', 80) }, { once: true });
  }
  function mountCheckoutRail() {
    if (window.DeckauraDeepReading && typeof window.DeckauraDeepReading.enable === 'function') return Promise.resolve(true);
    if (checkoutRailPromise) return checkoutRailPromise;
    var host = document.getElementById('ft-checkout-rail-host');
    var template = document.getElementById('ft-checkout-rail-template');
    var endpoint = host && host.getAttribute('data-ft-rail-endpoint');
    if (!host) return Promise.reject(new Error('checkout_ui_host_missing'));
    host.setAttribute('data-mounted', 'loading');
    function mountPayload(payload) {
      var fragment = document.createDocumentFragment();
      Array.prototype.slice.call(payload.childNodes).forEach(function (node) {
        if (node.nodeName !== 'SCRIPT') fragment.appendChild(document.importNode(node, true));
      });
      host.innerHTML = '';
      host.appendChild(fragment);
      Array.prototype.slice.call(payload.querySelectorAll('script')).forEach(function (oldScript) {
        var source = oldScript.getAttribute('src') || '';
        var isRuntimeScript = /(?:^|\/)deep-reading-cta-runtime\.js(?:[?#]|$)/.test(source);
        // Ancillary scripts must neither block runtime recovery nor install
        // duplicate global listeners when the required runtime is retried.
        if (source && !isRuntimeScript && checkoutRailAuxiliaryScripts[source] && checkoutRailAuxiliaryScripts[source] !== 'error') return;
        var nextScript = document.createElement('script');
        Array.prototype.slice.call(oldScript.attributes).forEach(function (attr) { nextScript.setAttribute(attr.name, attr.value); });
        nextScript.text = oldScript.textContent || '';
        if (source) {
          if (isRuntimeScript) checkoutRailRuntimePending += 1;
          else checkoutRailAuxiliaryScripts[source] = 'loading';
          // A slow script may finish after the UI timeout. Its load event must
          // reconnect pricing even though the original mount promise rejected.
          var settled = false;
          var onSettled = function (event) {
            if (settled) return;
            settled = true;
            if (isRuntimeScript) checkoutRailRuntimePending = Math.max(0, checkoutRailRuntimePending - 1);
            else checkoutRailAuxiliaryScripts[source] = event.type === 'error' ? 'error' : 'loaded';
            recoverLoadedCheckoutRail();
          };
          nextScript.addEventListener('load', onSettled, { once: true });
          nextScript.addEventListener('error', onSettled, { once: true });
        }
        host.appendChild(nextScript);
      });
      host.setAttribute('data-mounted', 'true');
      return new Promise(function (resolve, reject) { waitForCheckoutRail(resolve, reject, Date.now()); });
    }
    if (checkoutRailRuntimePending > 0) {
      // Retry checks the in-flight download instead of duplicating runtime
      // scripts and their checkout event handlers.
      checkoutRailPromise = new Promise(function (resolve, reject) { waitForCheckoutRail(resolve, reject, Date.now()); });
    } else if (template && template.content) {
      checkoutRailPromise = mountPayload(template.content);
    } else if (endpoint) {
      checkoutRailPromise = fetch(endpoint, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (response) {
        if (!response.ok) throw new Error('checkout_ui_http_' + response.status);
        return response.text();
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var payload = doc.querySelector('[data-ft-checkout-rail-payload]');
        if (!payload) throw new Error('checkout_ui_payload_missing');
        return mountPayload(payload);
      });
    } else {
      checkoutRailPromise = Promise.reject(new Error('checkout_ui_endpoint_missing'));
    }
    checkoutRailPromise = checkoutRailPromise.catch(function (error) {
      host.setAttribute('data-mounted', 'error');
      checkoutRailPromise = null;
      throw error;
    });
    return checkoutRailPromise;
  }

  /* ------------ server + rail ------------ */
  function cancelAnswerRequest() {
    var request = activeAnswerRequest;
    activeAnswerRequest = null;
    answerNavigationSuspended = false;
    s.busy = false;
    if (!request) return;
    if (request.timer) clearTimeout(request.timer);
    if (request.controller) request.controller.abort();
  }
  function suspendAnswerForNavigation() {
    if (!activeAnswerRequest || s.phase !== 'result' || !s.server || s.server.status !== 'loading') return;
    // Navigation aborts fetches too. Detach this request before its rejection
    // handler can turn the saved, resumable reading into a network error.
    cancelAnswerRequest();
    answerNavigationSuspended = true;
    persistState();
  }
  function retryAnswer() {
    if (s.phase !== 'result' || !s.readingId || s.busy || !s.server || s.server.status !== 'error') return false;
    s.server = { status: 'loading', answer: '' };
    render();
    fetchAnswer();
    return true;
  }
  function fetchAnswer() {
    if (answerNavigationSuspended || s.phase !== 'result' || !s.readingId || s.busy || (s.server && s.server.status !== 'loading')) return;
    s.busy = true;
    var startedAt = Date.now();
    var picks = drawn();
    var body = {
      spread: spreadKey(),
      question: s.q,
      category: cat(),
      visitorId: visitorId(),
      readingId: s.readingId,
      cards: picks.map(function (d, index) { return { name: d.card.name, orientation: d.rev ? 'reversed' : 'upright', position: currentSpread().pos[index] || 'Card ' + (index + 1) }; })
    };
    Object.assign(body, localePayload());
    var ac = typeof AbortController === 'function' ? new AbortController() : null;
    var request = { readingId: s.readingId, controller: ac, timer: 0 };
    activeAnswerRequest = request;
    function isCurrentRequest() {
      return activeAnswerRequest === request && s.readingId === request.readingId && s.phase === 'result';
    }
    request.timer = ac ? setTimeout(function () { ac.abort(); }, 14000) : 0;
    return fetch(API_BASE + '/answer', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body), signal: ac ? ac.signal : undefined
    }).then(function (r) {
      var response = { ok: r.ok, status: r.status, retryAfter: r.headers.get('retry-after') || '', data: null };
      return r.json().then(function (data) { response.data = data; return response; }, function () { return response; });
    })
      .then(function (res) {
        if (!isCurrentRequest()) return;
        if (res.ok && res.data && (res.data.preview || res.data.answer)) {
          rememberQuota(res.data, res.retryAfter, true);
          var preview = res.data.preview && typeof res.data.preview === 'object' ? res.data.preview : null;
          if (preview) {
            preview = {
              recognition: canonicalizeAnswerCardNames(preview.recognition, picks),
              tension: canonicalizeAnswerCardNames(preview.tension, picks),
              unresolvedQuestion: canonicalizeAnswerCardNames(preview.unresolvedQuestion, picks),
              cardInsights: Array.isArray(preview.cardInsights) ? preview.cardInsights.map(function (entry) {
                return Object.assign({}, entry, { insight: canonicalizeAnswerCardNames(entry && entry.insight, picks) });
              }) : []
            };
          }
          s.server = { status: 'ready', preview: preview, answer: canonicalizeAnswerCardNames(res.data.answer, picks), previewVersion: res.data.previewVersion || '', promptVersion: res.data.promptVersion || '', nextAt: quotaExpiresAt };
          var resultMode = /fallback/i.test(String(res.data.servedSource || '')) ? 'fallback' : 'success';
          publishFunnelEvent('free_result_resolved', { result_mode: resultMode, source: res.data.servedSource || 'api', preview_version: res.data.previewVersion || 'legacy', prompt_version: res.data.promptVersion || '', latency_ms: Date.now() - startedAt }, { once: true });
          publishFunnelEvent('free_recognition_viewed', { preview_version: res.data.previewVersion || 'legacy', category: cat(), spread: spreadKey() }, { once: true });
          if (preview && openQuestionText(localizeAnswerText(preview.unresolvedQuestion, picks))) publishFunnelEvent('free_unresolved_question_viewed', { preview_version: res.data.previewVersion || PREVIEW_VERSION }, { once: true });
        } else if (res.data && (res.data.safety === true || /(?:^|_)SAFETY_BLOCKED$/i.test(String(res.data.code || res.data.error || res.data.reason || '')))) {
          /* The reading service refused the question for safety: back to the question with the support message. */
          s.server = { status: 'refused', answer: '' };
          publishFunnelEvent('free_result_resolved', { result_mode: 'validation_error', reason: 'safety_blocked', latency_ms: Date.now() - startedAt }, { once: true });
        } else {
          var reason = String(res.data && (res.data.error || res.data.reason) || '');
          var limited = res.status === 429 || /free_limit|rate_limit/i.test(reason) || (res.data && res.data.freeReadings && Number(res.data.freeReadings.remaining) === 0);
          // Service capacity is shared across visitors, not a consumed personal allowance.
          if (limited && !isServiceCapacityLimit(res)) rememberQuota(res.data, res.retryAfter, false);
          s.server = { status: limited ? 'limited' : 'error', answer: '', nextAt: limited ? quotaExpiresAt : 0, limitScope: isServiceCapacityLimit(res) ? 'service_capacity' : '' };
          var responseMode = limited ? 'limit' : (/validation|invalid|question|required/i.test(reason) || res.status === 400 ? 'validation_error' : 'server_error');
          publishFunnelEvent('free_result_resolved', { result_mode: responseMode, reason: limited ? 'rolling_24h' : 'server_response', latency_ms: Date.now() - startedAt }, { once: true });
        }
      })
      .catch(function (error) {
        if (!isCurrentRequest()) return;
        s.server = { status: 'error', answer: '' };
        var mode = error && error.name === 'AbortError' ? 'timeout' : 'network_error';
        publishFunnelEvent('free_result_resolved', { result_mode: mode, reason: mode, latency_ms: Date.now() - startedAt }, { once: true });
      })
      .finally(function () {
        if (request.timer) clearTimeout(request.timer);
        if (!isCurrentRequest()) return;
        activeAnswerRequest = null;
        s.busy = false;
        if (s.server && s.server.status === 'refused') {
          s.safetyHeldQ = s.q;
          restart();
          showQuestionSupport(supportCopy('blocked'));
          return;
        }
        var offer = document.getElementById('ft-intent');
        var offerTop = offer ? offer.getBoundingClientRect().top : NaN;
        var slot = document.querySelector('#free-direction .ft-answer-slot');
        var slotTop = slot ? slot.getBoundingClientRect().top : NaN;
        render();
        keepOfferInPlace(offer, offerTop, slotTop);
      });
  }
  function keepOfferInPlace(offer, before, slotTop) {
    // The answer and open question appear above the offer. Hold the offer still only for a visitor who has
    // scrolled past the loading card to it; anyone still watching the card sees the answer land in place.
    var viewport = window.innerHeight;
    if (!offer || !Number.isFinite(before) || before > viewport * 0.4) return;
    if (Number.isFinite(slotTop) && slotTop >= 0 && slotTop < viewport) return;
    var delta = offer.getBoundingClientRect().top - before;
    if (Math.abs(delta) > 1) window.scrollBy(0, delta);
  }
  function enableRail() {
    if (s.phase !== 'result' || !s.readingId || !drawn().length) return false;
    var pendingReadingId = s.readingId;
    var api = window.DeckauraDeepReading;
    if (!api || typeof api.enable !== 'function') {
      mountCheckoutRail().then(function () {
        if (s.phase === 'result' && s.readingId === pendingReadingId) enableRail();
      }).catch(function (error) {
        checkoutRailFailed(error, pendingReadingId);
      });
      return false;
    }
    if (!drawn().length) return false;
    var SP = currentSpread();
    var C = CATS[cat()];
    var selectedIntent = intentConfig();
    var questions = checkoutQuestions();
    var railReadingId = s.readingId;
    var railPreview = freePatternPreview(s.server);
    var railOpenQuestion = railPreview ? openQuestionText(localizeAnswerText(railPreview.unresolvedQuestion, drawn())) : '';
    function checkoutProperties() {
      var currentFollowup = checkoutQuestions().followup;
      var properties = {
        '_presentation_variant': FUNNEL_VERSION,
        '_analytics_schema': ANALYTICS_SCHEMA,
        '_funnel_version': FUNNEL_VERSION,
        '_attempt_id': s.attemptId,
        '_reading_id': s.readingId,
        '_Reading Focus': selectedIntent ? selectedIntent.title : C.label
      };
      properties[msg('readingFocusLabel', null, 'Reading focus')] = selectedIntent ? selectedIntent.title : C.label;
      if (currentFollowup) {
        properties['_Selected Follow-up'] = currentFollowup;
        properties[msg('optionalFollowupLabel', null, 'Optional follow-up')] = currentFollowup;
      }
      return properties;
    }
    var railOptions = {
      type: 'Tarot', teaser: false, resultReady: true,
      presentationVariant: FUNNEL_VERSION,
      canonicalPage: PAGE, visitorId: visitorId(),
      question: questions.original, readingId: s.readingId,
      curiosityQuestion: questions.selected,
      focus: selectedIntent ? selectedIntent.title : C.label, fixedFocus: 'FreeTarot V2 - ' + cat(),
      context: 'Free Tarot V2 ' + SP.name + ' spread. Category: ' + cat() + '. ' + (questions.followup ? 'Optional visitor follow-up or detail: "' + questions.followup + '". ' : '') + 'Supplied question: "' + questions.original + '". Exact picked cast: ' + castStrings() + '. Interpret only these cards.' + (railOpenQuestion ? ' Open question shown with the free result: "' + railOpenQuestion + '". Address it directly.' : ''),
      signals: castStrings(),
      cards: castStrings(),
      spread: SP.name,
      scope: SP.name + ' reading for one focused question: ' + SP.pos.join(', ') + '.',
      confidence: 'Symbolic tarot guidance for reflection, not a factual or guaranteed prediction.',
      tool: PAGE,
      checkoutRecoveryHost: document.querySelector('[data-ft-cart-review]'),
      onCartReviewReady: cartReviewReady,
      checkoutProperties: checkoutProperties,
      checkoutGuard: function (detail) {
        var selectedQuote = (s.pricing.tiers || []).find(function (item) { return item.tier === detail.tier; });
        return pricingCheckoutReady() && !!(selectedQuote && selectedQuote.available && selectedQuote.variant_id === String(detail.variantId || ''));
      },
      onPricingStateChange: function (snapshot) {
        if (s.phase === 'result' && s.readingId === railReadingId) applyPricingSnapshot(snapshot);
      },
      onPriceReady: function () {
        if (!pricingCheckoutReady() || !s.checkoutQueued || s.railReadingId !== railReadingId || s.readingId !== railReadingId) return;
        window.setTimeout(continueQueuedCheckout, 0);
      }
    };
    try {
      if (s.railReadingId === railReadingId && typeof api.update === 'function') api.update(railOptions);
      else api.enable(railOptions);
      if (typeof api.setPreviewAuthorization === 'function') api.setPreviewAuthorization({ previewToken: '', transportFallback: false });
      if (typeof api.setCheckoutPending === 'function') api.setCheckoutPending(false);
      s.railReadingId = railReadingId;
      return true;
    } catch (_) { return false; }
  }
  function focusListItem(name, idx, selector, restoreY) {
    window.requestAnimationFrame(function () {
      if (Number.isFinite(restoreY)) window.scrollTo(0, restoreY);
      var holder = document.querySelector('[data-rv2-item="' + name + '"][data-rv2-idx="' + idx + '"]');
      var target = holder && holder.querySelector(selector || 'button');
      try { if (target) target.focus({ preventScroll: true }); } catch (_) {}
      if (Number.isFinite(restoreY)) {
        window.requestAnimationFrame(function () { window.scrollTo(0, restoreY); });
      }
    });
  }
  function lockSheetScroll() {
    if (!document.body) return;
    sheetBodyOverflow = document.body.style.overflow;
    sheetBodyPaddingRight = document.body.style.paddingRight;
    var gap = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    document.body.style.overflow = 'hidden';
    if (gap) document.body.style.paddingRight = gap + 'px';
  }
  function unlockSheetScroll() {
    if (!document.body) return;
    document.body.style.overflow = sheetBodyOverflow;
    document.body.style.paddingRight = sheetBodyPaddingRight;
  }
  function openSheet(trigger) {
    if (s.sheet) return;
    sheetScrollY = window.pageYOffset || 0;
    sheetTrigger = trigger || document.querySelector('[data-rv2-act="sheetopen"]');
    lockSheetScroll();
    s.sheet = true;
    render();
    window.requestAnimationFrame(function () {
      var dialog = document.querySelector('[data-rv2-sheet-backdrop]');
      var close = dialog && dialog.querySelector('[data-rv2-act="sheetclose"]');
      try { (close || dialog).focus({ preventScroll: true }); } catch (_) {}
    });
  }
  function closeSheet() {
    if (!s.sheet) return;
    var restoreY = sheetScrollY;
    var restoreFocus = sheetTrigger;
    s.sheet = false;
    render();
    unlockSheetScroll();
    window.requestAnimationFrame(function () {
      window.scrollTo(0, restoreY);
      try { if (restoreFocus && restoreFocus.isConnected) restoreFocus.focus({ preventScroll: true }); } catch (_) {}
    });
  }
  function checkoutStatus(message, isError) {
    pricingNoticeShown = false;
    if (isError && checkoutCartReviewPending()) { message = ''; isError = false; }
    var st = document.querySelector('[data-rv2-checkout-status]');
    if (!st) return;
    st.textContent = message || '';
    st.style.display = message ? 'block' : 'none';
    st.style.color = isError ? '#F4B4BC' : '#E3C98F';
    checkoutRecovery(isError === true);
  }
  function clearCartReview() {
    s.checkoutCartReview = null;
    var host = document.querySelector('[data-ft-cart-review]');
    if (!host) return;
    host.__deckauraRecoveryGeneration = (host.__deckauraRecoveryGeneration || 0) + 1;
    host.textContent = '';
    host.hidden = true;
  }
  function checkoutCartReviewReason(reason) {
    return /^(reading_cart_conflict|cart_changed|cart_operation_busy|cart_result_uncertain|cart_read_failed|cart_add_failed|checkout_guard_unavailable|checkout_navigation_busy)$/.test(String(reason || ''));
  }
  function checkoutCartReviewPending() {
    var review = s.checkoutCartReview;
    return !!(review && checkoutCartReviewReason(review.reason) && s.phase === 'result' && review.readingId === s.readingId && s.railReadingId === s.readingId && document.querySelector('[data-ft-cart-review]'));
  }
  function cartReviewReady(host) {
    if (!host || s.phase !== 'result') return;
    var readingId = s.readingId, generation = host.__deckauraRecoveryGeneration;
    if (host.__ftFocusedRecoveryGeneration === generation) return;
    host.__ftFocusedRecoveryGeneration = generation;
    window.requestAnimationFrame(function () {
      if (s.phase !== 'result' || s.readingId !== readingId || host.hidden || host.isConnected === false || host.__deckauraRecoveryGeneration !== generation) return;
      host.setAttribute('tabindex', '-1');
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      try { host.scrollIntoView({ block: 'start', behavior: reducedMotion ? 'auto' : 'smooth' }); } catch (_) {}
      try { host.focus({ preventScroll: true }); } catch (_) {}
    });
  }
  function checkoutRecovery(show) {
    var box = document.querySelector('[data-ft-checkout-recovery]');
    if (!box) return;
    var link = box.querySelector('[data-ft-checkout-recovery-link]');
    var tier = RAIL_TIERS[tierIndex()] || 'deeper';
    var attr = tier === 'essential' ? 'data-essential-url' : (tier === 'indepth' ? 'data-indepth-url' : 'data-focused-url');
    var directUrl = link && link.getAttribute(attr);
    if (link && directUrl) link.setAttribute('href', directUrl);
    box.hidden = show !== true;
  }
  function resetCheckout(message, isError) {
    s.checkoutQueued = false;
    s.checkoutVia = '';
    s.checkoutBusy = false;
    render();
    checkoutStatus(message || '', isError === true);
  }
  function retryPricing() {
    if (s.phase !== 'result' || !s.readingId) return false;
    var pendingReadingId = s.readingId;
    var api = window.DeckauraDeepReading;
    s.checkoutQueued = false;
    s.checkoutBusy = false;
    checkoutStatus(msg('retryingPrice', null, 'Retrying the secure price check…'), false);
    pricingNoticeShown = true;
    publishFunnelEvent('price_check_retried', { error_code: s.pricing.error_code || 'price_unavailable' });
    if (!api || typeof api.retryPricing !== 'function' || s.railReadingId !== s.readingId) {
      s.pricing.status = 'loading';
      s.pricing.error_code = '';
      s.pricing.retryable = false;
      render();
      mountCheckoutRail().then(function () {
        if (s.phase === 'result' && s.readingId === pendingReadingId) enableRail();
      }).catch(function (error) {
        checkoutRailFailed(error, pendingReadingId);
      });
      return true;
    }
    try {
      if (api && typeof api.retryPricing === 'function' && api.retryPricing()) return true;
    } catch (_) {}
    s.pricing.status = 'error';
    s.pricing.error_code = 'retry_unavailable';
    s.pricing.retryable = true;
    render();
    showPricingNotice();
    return false;
  }
  function railCheckout(via) {
    var api = window.DeckauraDeepReading;
    if (!api || typeof api.checkoutNow !== 'function') return false;
    if (!enableRail()) return false;
    var desiredTier = RAIL_TIERS[tierIndex()] || 'deeper';
    var verifiedTier = (s.pricing.tiers || []).find(function (item) { return item.tier === desiredTier; });
    if (!pricingCheckoutReady() || !verifiedTier || !verifiedTier.available) return null;
    try { api.setTier(desiredTier, 'user'); } catch (_) { return false; }
    try {
      if (typeof api.getSelectedTier === 'function' && api.getSelectedTier() !== desiredTier) return false;
      if (typeof api.isPriceReady === 'function' && !api.isPriceReady()) {
        s.checkoutQueued = true;
        s.checkoutVia = via || 'package_cta';
        publishFunnelEvent('checkout_price_waiting', { tier: desiredTier, via: s.checkoutVia });
        return null;
      }
      return api.checkoutNow() === true;
    } catch (_) { return false; }
  }
  function continueQueuedCheckout() {
    if (!s.checkoutQueued || !s.checkoutBusy) return;
    var via = s.checkoutVia || 'package_cta';
    s.checkoutQueued = false;
    var started = railCheckout(via + '_price_ready');
    if (started === null) {
      s.checkoutQueued = true;
      checkoutStatus(msg('confirmingMarketPrice', null, 'Confirming the secure price for your market…'), false);
      return;
    }
    if (!started && railHoldsForSafety()) { checkoutSupport('urgent'); return; }
    if (!started) {
      resetCheckout(msg('packageFailed', null, 'This package could not be prepared. Please choose it again or try another level.'), true);
      return;
    }
    checkoutStatus(msg('openingCheckout', null, 'Opening secure checkout…'), false);
  }
  function startCheckout(via) {
    if (s.checkoutBusy) {
      checkoutStatus(msg('checkoutAlready', null, 'Secure checkout is already being prepared…'), false);
      return;
    }
    clearCartReview();
    checkoutRecovery(false);
    publishFunnelEvent('checkout_cta_clicked', { tier: RAIL_TIERS[tierIndex()], via: via || 'package_cta' });
    if (s.phase !== 'result' || !drawn().length) {
      s.checkoutQueued = false;
      s.checkoutVia = '';
      s.live = msg('completeFreeFirst', null, 'Complete your free reading before choosing a package.');
      render();
      publishFunnelEvent('checkout_blocked', { reason: 'reading_incomplete', via: via || 'package_cta' });
      if (s.phase === 'ask') focusComposer();
      else scrollScreen('Reading chamber', 70);
      return;
    }
    if (!s.intent) {
      s.live = msg('chooseNeedFirst', null, 'Choose what you need to understand next before selecting a reading depth.');
      render();
      publishFunnelEvent('checkout_blocked', { reason: 'continuation_required', via: via || 'package_cta', category: cat() });
      goIntent();
      return;
    }
    // Optional follow-up text never gates checkout or price recovery, unless it is crisis wording.
    if (crisisUrgent(s.q) || crisisUrgent(s.followup) || railHoldsForSafety()) {
      checkoutSupport(railHoldsForSafety() && !crisisUrgent(s.q) && !crisisUrgent(s.followup) ? 'blocked' : 'urgent');
      publishFunnelEvent('checkout_blocked', { reason: 'support', via: via || 'package_cta' });
      return;
    }
    if (s.pricing.status === 'error') {
      if (s.pricing.retryable) retryPricing();
      else checkoutStatus(msg('checkoutConfigFailed', null, 'Checkout is temporarily unavailable because the product configuration could not be verified.'), true);
      return;
    }
    if (!Number.isInteger(s.tier) || s.tier < 0 || s.tier >= RAIL_TIERS.length) s.tier = 1;
    if (!pricingCheckoutReady()) {
      s.checkoutBusy = true;
      s.checkoutQueued = true;
      s.checkoutVia = via || 'package_cta';
      render();
      checkoutStatus(msg('confirmingMarketPrice', null, 'Confirming the secure price for your market…'), false);
      publishFunnelEvent('checkout_price_waiting', { tier: RAIL_TIERS[tierIndex()], via: s.checkoutVia });
      enableRail();
      return;
    }
    s.checkoutBusy = true;
    s.checkoutVia = via || 'package_cta';
    render();
    var started = railCheckout(via);
    if (started === null) {
      checkoutStatus(msg('confirmingMarketPrice', null, 'Confirming the secure price for your market…'), false);
    } else if (!started && railHoldsForSafety()) {
      checkoutSupport('urgent');
    } else if (!started) {
      resetCheckout(msg('checkoutFailed', null, 'Checkout could not be prepared. Please try again.'), true);
    } else {
      checkoutStatus(msg('openingCheckout', null, 'Opening secure checkout…'), false);
    }
  }

  /* ------------ flow ------------ */
  function releaseQuestionOverrides() {
    s.cat = null;
    s.spread = null;
    s.handoff = null;
    s.draft = '';
  }
  function drawGeneral() {
    if (s.q.trim()) { draw(); return; }
    releaseQuestionOverrides();
    s.cat = 'other';
    setComposerValue(CATS.other.general);
    s.qErr = false;
    ensureAttempt('general_reading');
    publishFunnelEvent('category_selected', { category: 'other', source: 'general_reading' });
    draw();
  }
  function draw() {
    if (s.drawBusy) {
      s.live = msg('loadingDeckSafe', null, 'The complete deck is still loading. Your question is safe.');
      return;
    }
    ensureAttempt('draw');
    var heldBySafety = !!s.safetyHeldQ && s.safetyHeldQ === s.q;
    if (heldBySafety || crisisUrgent(s.q)) {
      s.qErr = false;
      render();
      showQuestionSupport(supportCopy(heldBySafety ? 'blocked' : 'urgent'));
      focusComposer();
      persistState();
      publishFunnelEvent('question_validation_failed', { reason: 'support' });
      return;
    }
    showQuestionSupport('');
    if ((!s.cat && s.q.trim().length < MIN_QUESTION_LENGTH) || (s.q.trim() && s.q.trim().length < MIN_QUESTION_LENGTH)) {
      s.qErr = true; render(); focusComposer();
      publishFunnelEvent('question_validation_failed', { reason: s.q.trim() ? 'too_short' : 'missing_focus' });
      return;
    }
    if (!s.q.trim()) {
      s.q = CATS[cat()].general;
      setComposerValue(s.q);
    }
    publishFunnelEvent('question_validated', { category: cat() }, { once: true });
    publishFunnelEvent('draw_submitted', { spread: spreadKey(), category: cat() }, { once: true });
    var d = deckData();
    if (!d) {
      s.drawBusy = true;
      s.drawError = '';
      s.live = msg('deckLoading', null, 'Loading the complete 78-card deck.');
      render();
      var startedAt = Date.now();
      if (deckReadyTimer) clearInterval(deckReadyTimer);
      deckReadyTimer = window.setInterval(function () {
        if (deckData()) {
          clearInterval(deckReadyTimer);
          deckReadyTimer = 0;
          s.drawBusy = false;
          draw();
        } else if (Date.now() - startedAt > 6000) {
          clearInterval(deckReadyTimer);
          deckReadyTimer = 0;
          s.drawBusy = false;
          s.drawError = msg('deckLoadFailed', null, 'The cards could not load on this connection. Please try again—your question is still here.');
          s.live = s.drawError;
          render();
          publishFunnelEvent('draw_blocked', { reason: 'deck_load_timeout' });
        }
      }, 200);
      return;
    }
    var rng = rand(hash(s.q + spreadKey() + Date.now().toString(36)));
    var idx = [];
    d.forEach(function (_card, i2) { idx.push(i2); });
    for (var i = idx.length - 1; i > 0; i -= 1) {
      var j = Math.floor(rng() * (i + 1));
      var t = idx[i]; idx[i] = idx[j]; idx[j] = t;
    }
    clearCartReview();
    cancelAnswerRequest();
    s.positions = SPREADS[spreadKey()].pos.slice();
    s.deck = idx.slice(0, 15).map(function (di) { return { card: d[di], rev: rng() < 0.34 }; });
    s.picked = [];
    s.server = null;
    s.intent = ''; s.tier = null; s.followup = '';
    s.readingId = uuid('r_');
    s.resultIndex = 0;
    s.pricing = { status: 'idle', currency: '', latency_ms: 0, error_code: '', tiers: [] };
    pricingAutoRetryCount = 0;
    s.railReadingId = ''; s.checkoutQueued = false; s.checkoutVia = ''; s.checkoutBusy = false;
    s.phase = 'chamber'; s.qErr = false;
    s.drawBusy = false; s.drawError = '';
    s.live = msg('chooseCards', null, 'Choose your cards.');
    render();
    publishFunnelEvent('draw_succeeded', { spread: spreadKey(), category: cat(), card_count: need() }, { once: true });
    setTimeout(function () { scrollScreen('Reading chamber', 70); }, 60);
  }
  function reveal() {
    if (s.picked.length < need()) {
      var left = need() - s.picked.length;
      s.live = msg('chooseMoreToReveal', { n: left }, 'Choose ' + left + ' more ' + (left === 1 ? 'card' : 'cards') + ' to reveal your reading.');
      renderChamberSelection();
      publishFunnelEvent('draw_blocked', { reason: 'cards_incomplete', selected_count: s.picked.length, card_count: need(), spread: spreadKey() });
      setTimeout(function () {
        var chamber = document.querySelector('[data-screen-label="Reading chamber"]');
        var choice = chamber && chamber.querySelector('[data-rv2-item="deckCards"] button[aria-pressed="false"]');
        var rail = chamber && chamber.querySelector('[data-deck-rail="true"]');
        try {
          if (rail) rail.scrollIntoView({ block: 'center', behavior: 'smooth' });
          if (choice) choice.focus({ preventScroll: true });
        } catch (_) {}
      }, 40);
      return;
    }
    s.phase = 'result';
    s.resultIndex = 0;
    s.intent = DEFAULT_INTENT_ID;
    s.tier = 1;
    var knownLimited = s.entitlementStatus === 'ready' && quotaActive();
    s.server = { status: knownLimited ? 'limited' : 'loading', answer: '', nextAt: knownLimited ? quotaExpiresAt : 0 };
    s.live = knownLimited ? msg('cardsReadyLimited', { time: quotaLabel() }, 'Your cards are ready. A new free reading opens ' + quotaLabel() + '.') : msg('freeReady', null, 'Your free reading is ready.');
    render();
    publishFunnelEvent('free_result_requested', { spread: spreadKey(), category: cat(), card_count: need() }, { once: true });
    if (knownLimited) publishFunnelEvent('free_result_resolved', { result_mode: 'limit', reason: 'rolling_24h', source: 'local_entitlement' }, { once: true });
    enableRail();
    setTimeout(function () { scrollScreen('Free result', 70); }, 60);
    if (!knownLimited) fetchAnswer();
  }
  function restart() {
    cancelAnswerRequest();
    clearCartReview();
    if (deckReadyTimer) { clearInterval(deckReadyTimer); deckReadyTimer = 0; }
    s.phase = 'ask'; s.positions = null; s.picked = []; s.deck = []; s.tier = null; s.intent = ''; s.server = null; s.live = ''; s.qErr = false; s.followup = ''; s.sheet = false;
    setComposerValue(s.q);
    s.drawBusy = false; s.drawError = '';
    s.attemptId = ''; s.readingId = ''; s.sentEvents = {}; s.questionStarted = false; s.resultIndex = 0; engagedMs = 0; engagedVisible = false;
    s.pricing = { status: 'idle', currency: '', latency_ms: 0, error_code: '', tiers: [] };
    s.railReadingId = ''; s.checkoutQueued = false; s.checkoutVia = ''; s.checkoutBusy = false;
    try { if (window.DeckauraDeepReading && typeof window.DeckauraDeepReading.disable === 'function') window.DeckauraDeepReading.disable(); } catch (_) {}
    render();
    ensureAttempt('change_question');
    window.setTimeout(focusComposer, 40);
  }
  function startOver() {
    setComposerValue(''); s.draft = ''; s.cat = null; s.spread = null; s.handoff = null;
    restart();
    publishFunnelEvent('funnel_started_over', { source: 'explicit_reset' });
  }
  function advanceResult() {
    var rail = document.querySelector('[data-screen-label="Free result"] [data-deck-rail="true"]');
    var answer = document.getElementById('free-direction');
    if (!rail) return;
    var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
    if (s.resultIndex >= need() - 1 || max < 8 || rail.scrollLeft >= max - 24) {
      var offer = document.getElementById('ft-intent');
      if (offer) offer.scrollIntoView({ block: 'start', behavior: 'smooth' });
      publishFunnelEvent('free_result_navigation', { destination: 'reading_options', result_index: need(), result_total: need() });
      return;
    }
    var railRect = rail.getBoundingClientRect();
    var cards = Array.prototype.slice.call(rail.querySelectorAll('.ft-result-card'));
    var next = cards.filter(function (card) {
      return card.getBoundingClientRect().left > railRect.left + 12;
    })[0];
    var left = next
      ? Math.min(max, rail.scrollLeft + next.getBoundingClientRect().left - railRect.left)
      : Math.min(max, rail.scrollLeft + rail.clientWidth * 0.82);
    try { rail.scrollTo({ left: left, behavior: 'smooth' }); } catch (_) { rail.scrollLeft = left; }
    s.resultIndex = Math.min(need() - 1, s.resultIndex + 1);
    render();
    publishFunnelEvent('free_result_navigation', { destination: 'next_card', result_index: s.resultIndex + 1, result_total: need() });
  }

  /* ------------ events ------------ */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var heroStart = t.closest('[data-ft-hero-card-start]');
    if (heroStart) {
      ensureAttempt('hero_cards');
      publishFunnelEvent('hero_card_start_clicked', { destination: 'question_composer' }, { once: true });
      window.setTimeout(focusComposer, 320);
      return;
    }
    var relatedReading = t.closest('a[data-ft-related-reading]');
    if (relatedReading && relatedReading.closest('[data-ft-scope]')) {
      ensureAttempt('related_reading');
      publishFunnelEvent('related_reading_clicked', {
        source: 'question_composer',
        destination: relatedReading.getAttribute('data-ft-related-reading') || 'unknown'
      });
      return;
    }
    if (s.sheet && t.matches('[data-rv2-sheet-backdrop]')) {
      ev.preventDefault();
      closeSheet();
      return;
    }
    var act = t.closest('[data-rv2-act]');
    if (act && act.closest('[data-ft-scope]')) {
      var a = act.getAttribute('data-rv2-act');
      if (a === 'focusask') { ev.preventDefault(); if (s.phase !== 'ask') restart(); focusComposer(); }
      else if (a === 'draw') { ev.preventDefault(); draw(); }
      else if (a === 'generaldraw') { ev.preventDefault(); drawGeneral(); }
      else if (a === 'sheetopen') { ev.preventDefault(); openSheet(act); }
      else if (a === 'sheetclose') { ev.preventDefault(); closeSheet(); }
      else if (a === 'reveal') { ev.preventDefault(); reveal(); }
      else if (a === 'restart' || a === 'top') { ev.preventDefault(); restart(); }
      else if (a === 'startover') { ev.preventDefault(); startOver(); }
      else if (a === 'restoredraft') {
        ev.preventDefault();
        setComposerValue(s.draft); releaseQuestionOverrides(); s.qErr = false;
        publishFunnelEvent('draft_restore_accepted', { source: 'session_draft' }, { once: true });
        render(); focusComposer();
      }
      else if (a === 'resumelast') { ev.preventDefault(); resumeLastReading(); }
      else if (a === 'resumeother') { ev.preventDefault(); resumeOtherLanguageReading(); }
      else if (a === 'nextresult') { ev.preventDefault(); advanceResult(); }
      else if (a === 'limitoffer') {
        ev.preventDefault();
        publishFunnelEvent('offer_opened', { source: 'free_limit', tier: RAIL_TIERS[tierIndex()] });
        goIntent();
      }
      else if (a === 'skipresult') {
        publishFunnelEvent('free_result_navigation', { destination: 'free_answer', result_index: s.resultIndex + 1, result_total: need() });
      }
      else if (a === 'offeropen') {
        ev.preventDefault();
        publishFunnelEvent('offer_opened', { intent: s.intent, tier: RAIL_TIERS[tierIndex()] }, { once: true });
        publishFunnelEvent('paid_primary_cta_clicked', { intent: s.intent, tier: RAIL_TIERS[tierIndex()] }, { once: true });
        startCheckout('primary_result_cta');
      }
      else if (a === 'retryprice') { ev.preventDefault(); retryPricing(); }
      else if (a === 'retryanswer') { ev.preventDefault(); retryAnswer(); }
      else if (a === 'barcheckout') { ev.preventDefault(); startCheckout('sticky_bar'); }
      return;
    }
    var item = t.closest('[data-rv2-item]');
    if (!item || !item.closest('[data-ft-scope]')) return;
    var listName = item.getAttribute('data-rv2-item');
    var idx = Number(item.getAttribute('data-rv2-idx'));
    var sub = t.closest('[data-rv2-subact]');
    if (listName === 'cats') {
      ensureAttempt('category');
      var catScrollY = window.pageYOffset;
      var keys = Object.keys(CATS);
      s.cat = s.cat === keys[idx] ? null : keys[idx];
      s.spread = null; s.handoff = null;
      s.qErr = false;
      publishFunnelEvent('category_selected', { category: s.cat || 'auto' });
      render();
      focusListItem('cats', idx, null, catScrollY);
    }
    else if (listName === 'examples') {
      var example = CATS[cat()].examples[idx];
      if (!example) return;
      ensureAttempt('question_example');
      setComposerValue(example);
      s.qErr = false;
      if (!s.questionStarted) {
        s.questionStarted = true;
        publishFunnelEvent('question_started', { category: cat(), source: 'example' }, { once: true });
      }
      publishFunnelEvent('question_example_selected', { category: cat(), source: 'example' });
      render();
      focusListItem('examples', idx, null, window.pageYOffset);
    }
    else if (listName === 'spreads') {
      var spreadKeys = Object.keys(SPREADS).filter(function (key) { return !SPREADS[key].sourceOnly; });
      s.spread = spreadKeys[idx];
      s.handoff = null;
      s.picked = [];
      publishFunnelEvent('spread_selected', { spread: s.spread });
      closeSheet();
    }
    else if (listName === 'deckCards') {
      if (s.phase !== 'chamber') return;
      var cardScrollY = window.pageYOffset;
      var p = s.picked.slice();
      var at = p.indexOf(idx);
      var removeSelected = sub && sub.getAttribute('data-rv2-subact') === 'remove';
      if (removeSelected) {
        if (at < 0) return;
        p.splice(at, 1);
      } else {
        if (at >= 0 || p.length >= need()) { if (p.length >= need()) { try { document.dispatchEvent(new CustomEvent('ft:deck-full', { detail: { total: need() } })); } catch (_) {} } return; }
        p.push(idx);
      }
      s.picked = p;
      s.live = p.length === need()
        ? msg('allSelected', null, 'All cards selected. Reveal your reading.')
        : msg('selectionCount', { selected: p.length, total: need() }, p.length + ' of ' + need() + ' selected');
      renderChamberSelection();
      if (p.length === need()) publishFunnelEvent('cards_completed', { spread: spreadKey(), card_count: need(), selected_count: p.length }, { once: true });
      focusListItem('deckCards', idx, null, cardScrollY);
      if (!removeSelected && p.length === need()) { try { document.dispatchEvent(new CustomEvent('ft:deck-complete', { detail: { total: need() } })); } catch (_) {} }
    }
    else if (listName === 'tierChoices') {
      var choiceScrollY = window.pageYOffset;
      var choiceIndex = Number(item.querySelector('[data-tier-index]') && item.querySelector('[data-tier-index]').getAttribute('data-tier-index'));
      if (!Number.isInteger(choiceIndex) || choiceIndex < 0 || choiceIndex >= RAIL_TIERS.length) return;
      s.tier = choiceIndex;
      publishFunnelEvent('package_selected', { tier: RAIL_TIERS[choiceIndex], via: 'price_selector' });
      render();
      focusListItem('tierChoices', idx, null, choiceScrollY);
    }
    else if (listName === 'tiers' || listName === 'primaryTiers' || listName === 'alternativeTiers') {
      var tierScrollY = window.pageYOffset;
      var realIdx = Number(item.querySelector('[data-tier-index]') && item.querySelector('[data-tier-index]').getAttribute('data-tier-index'));
      if (!Number.isInteger(realIdx) || !TIERS[realIdx]) realIdx = idx;
      if (!Number.isInteger(realIdx) || realIdx < 0 || realIdx >= RAIL_TIERS.length) return;
      s.tier = realIdx;
      if (sub && sub.getAttribute('data-rv2-subact') === 'buy') {
        publishFunnelEvent('package_selected', { tier: RAIL_TIERS[realIdx], via: 'package_cta' });
        render();
        ev.preventDefault();
        startCheckout('package_cta');
        return;
      }
      publishFunnelEvent('package_selected', { tier: RAIL_TIERS[realIdx], via: 'package_card' });
      render();
      focusListItem('tiers', idx, '[data-rv2-subact="select"]', tierScrollY);
    }
    else if (listName === 'intents') {
      var intentScrollY = window.pageYOffset;
      var selected = INTENTS[idx];
      if (!selected) return;
      s.intent = selected.id;
      s.tier = selected.tier;
      s.railReadingId = '';
      render();
      focusListItem('intents', idx, null, intentScrollY);
      enableRail();
      publishFunnelEvent('continuation_selected', { intent: selected.id, category: cat(), tier: RAIL_TIERS[selected.tier] });
    }
    else if (listName === 'faqs') {
      var faqScrollY = window.pageYOffset;
      s.faq = s.faq === idx ? -1 : idx;
      render();
      focusListItem('faqs', idx, null, faqScrollY);
    }
  });
  document.addEventListener('keydown', function (ev) {
    if (!s.sheet) return;
    var dialog = document.querySelector('[data-rv2-sheet-backdrop]');
    if (!dialog) return;
    if (ev.key === 'Escape') {
      ev.preventDefault();
      closeSheet();
      return;
    }
    if (ev.key !== 'Tab') return;
    var focusable = Array.prototype.filter.call(
      dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0; }
    );
    if (!focusable.length) { ev.preventDefault(); dialog.focus({ preventScroll: true }); return; }
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); last.focus({ preventScroll: true }); }
    else if (!ev.shiftKey && document.activeElement === last) { ev.preventDefault(); first.focus({ preventScroll: true }); }
  });
  document.addEventListener('input', function (ev) {
    var t = ev.target;
    if (t && t.matches && t.matches('input[data-ft-package-choice]')) {
      if (s.checkoutBusy) { render(); return; }
      var packageTier = Number(t.value);
      if (!Number.isInteger(packageTier) || packageTier < 0 || packageTier >= RAIL_TIERS.length) return;
      if (packageTier !== s.tier) clearCartReview();
      s.tier = packageTier;
      render();
      publishFunnelEvent('package_selected', { tier: RAIL_TIERS[packageTier], via: 'package_selector' });
      return;
    }
    if (t && t.matches && t.matches('textarea[data-ft-followup]')) {
      if (s.checkoutBusy) { t.value = s.followup; return; }
      var nextFollowup = t.value.slice(0, 240);
      if (nextFollowup !== s.followup) clearCartReview();
      s.followup = nextFollowup;
      var followupCounter = document.querySelector('[data-rv2-bind="followupCount"]');
      if (followupCounter) followupCounter.textContent = followupCount();
      persistState();
      return;
    }
    if (t && t.matches && t.matches('textarea[data-rv2-question]')) {
      if (s.phase !== 'ask') {
        t.value = s.q;
        return;
      }
      var nextQuestion = t.value.slice(0, 240);
      var manuallyChanged = nextQuestion !== s.q;
      s.q = nextQuestion;
      if (manuallyChanged) showQuestionSupport('');
      if (manuallyChanged && s.phase === 'ask') releaseQuestionOverrides();
      if (s.q.trim()) {
        ensureAttempt('question');
        if (!s.questionStarted) {
          s.questionStarted = true;
          publishFunnelEvent('question_started', { category: cat() }, { once: true });
        }
      }
      s.qErr = false;
      t.setAttribute('aria-invalid', 'false');
      t.setAttribute('aria-describedby', 'ft-topic-help');
      var counter = document.querySelector('[data-rv2-bind="charCount"]');
      if (counter) counter.textContent = questionCount();
      document.querySelectorAll('[data-rv2-if="qErr"]').forEach(function (el) { el.style.display = 'none'; });
      var drawReady = !s.drawBusy && s.q.trim().length >= MIN_QUESTION_LENGTH;
      document.querySelectorAll('[data-rv2-act="draw"]').forEach(function (button) {
        button.disabled = !!s.drawBusy;
        button.setAttribute('data-waiting', String(s.drawBusy || (!s.cat && s.q.trim().length < MIN_QUESTION_LENGTH)));
        if (!s.drawBusy) button.removeAttribute('aria-disabled');
        else button.setAttribute('aria-disabled', 'true');
      });
      persistState();
      /* Keep typing on the browser's native fast path. The next explicit
         action renders the derived spread; rebuilding the whole funnel on
         every keystroke created avoidable mobile INP and focus friction. */
    }
  });
  document.addEventListener('scroll', function (ev) {
    var rail = ev.target;
    if (!rail || !rail.matches || !rail.matches('.ft-result-rail')) return;
    if (rail.__ftScrollFrame) return;
    rail.__ftScrollFrame = window.requestAnimationFrame(function () {
      rail.__ftScrollFrame = 0;
      var cards = Array.prototype.slice.call(rail.querySelectorAll('.ft-result-card'));
      var left = rail.getBoundingClientRect().left;
      var best = 0, distance = Infinity;
      cards.forEach(function (card, index) {
        var nextDistance = Math.abs(card.getBoundingClientRect().left - left);
        if (nextDistance < distance) { best = index; distance = nextDistance; }
      });
      if (best === s.resultIndex) return;
      s.resultIndex = best;
      document.querySelectorAll('[data-rv2-bind="resultSwipeHint"]').forEach(function (el) { el.textContent = (best + 1) + ' / ' + Math.max(1, need()); });
      document.querySelectorAll('[data-rv2-bind="resultActionLabel"]').forEach(function (el) { el.textContent = best >= need() - 1 ? msg('showFreeReading', null, 'Show My Free Reading') : msg('nextCard', null, 'Next card'); });
      persistState();
    });
  }, true);
  document.addEventListener('deckaura:funnel-event', function (ev) {
    var detail = ev && ev.detail || {};
    var name = detail.name || '';
    if (name === 'checkout_prepare_start') {
      s.checkoutCartReview = null;
      if (s.phase === 'result' && s.readingId && s.railReadingId === s.readingId) {
        s.checkoutBusy = true;
        s.checkoutQueued = false;
        render();
        checkoutRecovery(false);
      }
    } else if (name === 'checkout_cart_ready') {
      if (s.checkoutBusy) checkoutStatus(msg('readingAttached', null, 'Reading attached. Opening secure checkout…'), false);
      publishFunnelEvent('checkout_cart_verified', { tier: RAIL_TIERS[tierIndex()] }, { once: true });
    } else if (name === 'checkout_redirect_success') {
      publishFunnelEvent('checkout_started', { tier: RAIL_TIERS[tierIndex()], via: s.checkoutVia || 'package_cta' }, { once: true });
    } else if (name === 'checkout_prepare_error') {
      var checkoutReason = String(detail.reason || (detail.data && (detail.data.reason || detail.data.status)) || 'prepare_error');
      s.checkoutCartReview = checkoutCartReviewReason(checkoutReason) && s.phase === 'result' && s.readingId && s.railReadingId === s.readingId ? { readingId: s.readingId, reason: checkoutReason } : null;
      publishFunnelEvent('checkout_failed', { tier: RAIL_TIERS[tierIndex()], reason: checkoutReason });
      /* A *_SAFETY_BLOCKED refusal from the reading service gets the support message, never "try again". */
      var refusalCode = String(detail.data && detail.data.code || detail.code || '');
      if (/(?:^|_)SAFETY_BLOCKED$/i.test(refusalCode) || /safety_blocked/i.test(checkoutReason)) {
        s.checkoutCartReview = null;
        checkoutSupport('blocked');
        return;
      }
      if (s.checkoutBusy) resetCheckout(msg('checkoutDidNotOpen', null, 'Checkout did not open. Your reading is safe—please try again.'), true);
      if (checkoutCartReviewPending()) checkoutStatus('', false);
    }
  });
  window.addEventListener('resize', function () {
    var w = window.innerWidth;
    if (Math.abs(w - s.w) > 4) { s.w = w; render(); }
  });
  window.addEventListener('beforeunload', suspendAnswerForNavigation);
  window.addEventListener('pagehide', suspendAnswerForNavigation);
  window.addEventListener('pagehide', function () { persistState(true); });
  window.addEventListener('pageshow', function (ev) {
    if (ev.persisted && s.checkoutBusy) {
      window.location.reload();
      return;
    }
    var resumeAnswer = answerNavigationSuspended || ev.persisted;
    answerNavigationSuspended = false;
    if (resumeAnswer && s.phase === 'result' && s.server && s.server.status === 'loading') fetchAnswer();
    if (!ev.persisted && !s.checkoutBusy) return;
    s.checkoutQueued = false;
    s.checkoutVia = '';
    s.checkoutBusy = false;
    render();
    if (s.phase === 'result' && s.intent) enableRail();
  });

  function simplifyVisibleResourceLabels() {
    document.querySelectorAll('a[href*="/pages/ai-data-sources"]').forEach(function (link) {
      if (/\bAI\b/i.test(link.textContent || '')) link.textContent = 'Open Data Resources';
      if (/\bAI\b/i.test(link.getAttribute('aria-label') || '')) link.setAttribute('aria-label', 'Open Data Resources');
      if (/\bAI\b/i.test(link.getAttribute('title') || '')) link.setAttribute('title', 'Open Data Resources');
    });
  }

  function boot() {
    if (I18N && typeof I18N.apply === 'function') I18N.apply(document);
    simplifyVisibleResourceLabels();
    s.sessionId = sessionId();
    quotaExpiresAt = readQuotaExpiry();
    restoreResumeCache();
    var initialComposer = document.querySelector('textarea[data-rv2-question]');
    var initialQuestion = initialComposer ? String(initialComposer.value || '').slice(0, 240) : '';
    var restored = restoreState();
    if (s.phase === 'ask' && initialQuestion) s.q = initialQuestion;
    var handoff = consumeGuideHandoff();
    setComposerValue(s.q);
    if (!s.sessionId) s.sessionId = sessionId();
    if (handoff) {
      ensureAttempt('tarot_spreads_handoff');
      publishFunnelEvent('reading_started', {
        source: 'tarot_spreads',
        spread: handoff.key,
        spread_name: handoff.name,
        card_count: handoff.positions.length,
        category: handoff.category
      }, { once: true });
      render();
      draw();
      return;
    }
    if (restored && s.phase === 'result' && !s.intent) s.intent = DEFAULT_INTENT_ID;
    if (restored && s.phase === 'result' && (!Number.isInteger(s.tier) || s.tier < 0 || s.tier >= RAIL_TIERS.length)) s.tier = 1;
    render();
    if (restored && s.phase === 'result') enableRail();
    if (restored && s.phase === 'result' && s.server && s.server.status === 'loading') fetchAnswer();
    publishFunnelEvent('tarot_funnel_viewed', { source: restored ? 'restored' : 'new' });
    if (s.draft && !s.q) publishFunnelEvent('draft_restore_offered', { source: 'session_draft' }, { once: true });
    if (s.resumeAvailable) publishFunnelEvent('quota_resume_shown', { source: 'resume_cache' }, { once: true });
    checkEntitlement();
    window.setInterval(function () {
      if (quotaExpiresAt && quotaExpiresAt <= Date.now() && s.phase === 'result' && s.server && s.server.status === 'limited') {
        quotaActive();
        s.server = { status: 'loading', answer: '' };
        render();
        fetchAnswer();
        return;
      }
      if (quotaExpiresAt && (s.phase === 'ask' || (s.server && s.server.status === 'limited'))) render();
    }, 60000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
